"use strict";
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    AdvancedTracking: function() {
        return AdvancedTracking;
    },
    Airport: function() {
        return Airport;
    },
    AuditLog: function() {
        return AuditLog;
    },
    AuditLogType: function() {
        return AuditLogType;
    },
    AuditLogTypeUtil: function() {
        return AuditLogTypeUtil;
    },
    CannulationType: function() {
        return CannulationType;
    },
    CannulationTypeUtil: function() {
        return CannulationTypeUtil;
    },
    Destination: function() {
        return Destination;
    },
    DistanceUnit: function() {
        return DistanceUnit;
    },
    Document: function() {
        return Document;
    },
    DonationType: function() {
        return DonationType;
    },
    DonationTypeUtil: function() {
        return DonationTypeUtil;
    },
    Flight: function() {
        return Flight;
    },
    FlightDestinationType: function() {
        return FlightDestinationType;
    },
    FlightPosition: function() {
        return FlightPosition;
    },
    FlightState: function() {
        return FlightState;
    },
    FlightStateUtil: function() {
        return FlightStateUtil;
    },
    Log: function() {
        return Log;
    },
    LoggerLocation: function() {
        return LoggerLocation;
    },
    LungPositionType: function() {
        return LungPositionType;
    },
    Notification: function() {
        return Notification;
    },
    NotificationUtil: function() {
        return NotificationUtil;
    },
    OrganPositionType: function() {
        return OrganPositionType;
    },
    OrganType: function() {
        return OrganType;
    },
    OrganTypeUtil: function() {
        return OrganTypeUtil;
    },
    Organization: function() {
        return Organization;
    },
    OrganizationMember: function() {
        return OrganizationMember;
    },
    OrganizationMemberAccessRole: function() {
        return OrganizationMemberAccessRole;
    },
    OrganizationMemberAccessRoleUtil: function() {
        return OrganizationMemberAccessRoleUtil;
    },
    OrganizationMemberDeactivationReason: function() {
        return OrganizationMemberDeactivationReason;
    },
    OrganizationMemberDeactivationReasonUtil: function() {
        return OrganizationMemberDeactivationReasonUtil;
    },
    OrganizationMemberRole: function() {
        return OrganizationMemberRole;
    },
    OrganizationMemberStatus: function() {
        return OrganizationMemberStatus;
    },
    OrganizationMemberStatusUtil: function() {
        return OrganizationMemberStatusUtil;
    },
    OrganizationOption: function() {
        return OrganizationOption;
    },
    OrganizationPreselectedMember: function() {
        return OrganizationPreselectedMember;
    },
    OrganizationStatus: function() {
        return OrganizationStatus;
    },
    OrganizationStatusUtil: function() {
        return OrganizationStatusUtil;
    },
    OrganizationType: function() {
        return OrganizationType;
    },
    OrganizationUnregisteredInvite: function() {
        return OrganizationUnregisteredInvite;
    },
    Product: function() {
        return Product;
    },
    ProductType: function() {
        return ProductType;
    },
    ProductUtil: function() {
        return ProductUtil;
    },
    Reading: function() {
        return Reading;
    },
    ReadingCompressed: function() {
        return ReadingCompressed;
    },
    Session: function() {
        return Session;
    },
    SessionIschemicTime: function() {
        return SessionIschemicTime;
    },
    SessionMember: function() {
        return SessionMember;
    },
    SessionMetadata: function() {
        return SessionMetadata;
    },
    SessionMetrics: function() {
        return SessionMetrics;
    },
    SessionReportData: function() {
        return SessionReportData;
    },
    SessionState: function() {
        return SessionState;
    },
    SessionType: function() {
        return SessionType;
    },
    SessionTypeUtil: function() {
        return SessionTypeUtil;
    },
    TimelineEntry: function() {
        return TimelineEntry;
    },
    TimelineEntryType: function() {
        return TimelineEntryType;
    },
    TimelineEntryTypeUtil: function() {
        return TimelineEntryTypeUtil;
    },
    Tutorial: function() {
        return Tutorial;
    },
    User: function() {
        return User;
    },
    UserDeactivationReason: function() {
        return UserDeactivationReason;
    },
    UserDeactivationReasonUtil: function() {
        return UserDeactivationReasonUtil;
    },
    UserSettings: function() {
        return UserSettings;
    },
    auditLogConverter: function() {
        return auditLogConverter;
    },
    calculateSessionStats: function() {
        return calculateSessionStats;
    },
    calculateUserStats: function() {
        return calculateUserStats;
    },
    destinationConverter: function() {
        return destinationConverter;
    },
    documentConverter: function() {
        return documentConverter;
    },
    filterSessions: function() {
        return filterSessions;
    },
    findClosestReadingTime: function() {
        return findClosestReadingTime;
    },
    generateCsvDataFromExportables: function() {
        return generateCsvDataFromExportables;
    },
    generateCsvDataFromSessions: function() {
        return generateCsvDataFromSessions;
    },
    generateEmailReportData: function() {
        return generateEmailReportData;
    },
    generateSessionMetrics: function() {
        return generateSessionMetrics;
    },
    locationConverter: function() {
        return locationConverter;
    },
    logConverter: function() {
        return logConverter;
    },
    organizationConverter: function() {
        return organizationConverter;
    },
    organizationMemberConverter: function() {
        return organizationMemberConverter;
    },
    organizationMemberRoleConverter: function() {
        return organizationMemberRoleConverter;
    },
    organizationOptionConverter: function() {
        return organizationOptionConverter;
    },
    organizationPreselectedMemberConverter: function() {
        return organizationPreselectedMemberConverter;
    },
    organizationTypeConverter: function() {
        return organizationTypeConverter;
    },
    organizationUnregisteredInviteConverter: function() {
        return organizationUnregisteredInviteConverter;
    },
    productConverter: function() {
        return productConverter;
    },
    sessionConverter: function() {
        return sessionConverter;
    },
    sessionMemberConverter: function() {
        return sessionMemberConverter;
    },
    timelineConverter: function() {
        return timelineConverter;
    },
    tiveLocationConverter: function() {
        return tiveLocationConverter;
    },
    tutorialConverter: function() {
        return tutorialConverter;
    },
    userConverter: function() {
        return userConverter;
    }
});
module.exports = __toCommonJS(src_exports);
// src/models/AuditLog.ts
var AuditLog = function AuditLog(param) {
    var userId = param.userId, event = param.event, context = param.context, timestampUser = param.timestampUser, timestampServer = param.timestampServer, timezone = param.timezone, appVersion = param.appVersion, osVersion = param.osVersion, os = param.os, device = param.device;
    _classCallCheck(this, AuditLog);
    this.userId = userId;
    this.event = event;
    this.context = context;
    this.timestampUser = timestampUser;
    this.timestampServer = timestampServer;
    this.timezone = timezone;
    this.appVersion = appVersion;
    this.osVersion = osVersion;
    this.os = os;
    this.device = device;
};
// src/converters/auditLog.converter.ts
var auditLogConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_timestampUser, _data_timestampServer;
        var data = doc.data();
        return new AuditLog(_objectSpreadProps(_objectSpread({}, data), {
            timestampUser: (_data_timestampUser = data.timestampUser) === null || _data_timestampUser === void 0 ? void 0 : _data_timestampUser.toDate(),
            timestampServer: (_data_timestampServer = data.timestampServer) === null || _data_timestampServer === void 0 ? void 0 : _data_timestampServer.toDate()
        }));
    }
};
// src/models/AdvancedTracking.ts
var AdvancedTracking = function AdvancedTracking(param) {
    var acceleration = param.acceleration, externalTemperature = param.externalTemperature, humidity = param.humidity, latitude = param.latitude, light = param.light, longitude = param.longitude, pressure3 = param.pressure, temperature3 = param.temperature, timestamp = param.timestamp;
    _classCallCheck(this, AdvancedTracking);
    this.acceleration = acceleration;
    this.externalTemperature = externalTemperature;
    this.humidity = humidity;
    this.latitude = latitude;
    this.light = light;
    this.longitude = longitude;
    this.pressure = pressure3;
    this.temperature = temperature3;
    this.timestamp = timestamp;
};
// src/models/Airport.ts
var Airport = /*#__PURE__*/ function() {
    function Airport(param) {
        var name = param.name, city = param.city, code = param.code, countryCode = param.countryCode, timezone = param.timezone, longitude = param.longitude, latitude = param.latitude;
        _classCallCheck(this, Airport);
        this.name = name;
        this.city = city;
        this.code = code;
        this.countryCode = countryCode;
        this.timezone = timezone;
        this.longitude = longitude;
        this.latitude = latitude;
    }
    _createClass(Airport, [
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    name: this.name,
                    city: this.city,
                    code: this.code,
                    countryCode: this.countryCode,
                    timezone: this.timezone,
                    longitude: this.longitude,
                    latitude: this.latitude
                };
            }
        }
    ]);
    return Airport;
}();
// src/models/AuditLogType.ts
var AuditLogType = /* @__PURE__ */ function(AuditLogType2) {
    AuditLogType2["SESSION_CREATED"] = "SESSION_CREATED";
    AuditLogType2["SESSION_JOINED"] = "SESSION_JOINED";
    AuditLogType2["SESSION_LEFT"] = "SESSION_LEFT";
    AuditLogType2["SESSION_STOPPED"] = "SESSION_STOPPED";
    AuditLogType2["LOGGER_STARTED"] = "LOGGER_STARTED";
    AuditLogType2["LOGGER_CONNECTED"] = "LOGGER_CONNECTED";
    AuditLogType2["LOGGER_DISCONNECTED"] = "LOGGER_DISCONNECTED";
    AuditLogType2["LOGGER_STOPPED"] = "LOGGER_STOPPED";
    AuditLogType2["TIMELINEENTRY_ADDED"] = "TIMELINEENTRY_ADDED";
    AuditLogType2["TIMELINEENTRY_UPDATED"] = "TIMELINEENTRY_UPDATED";
    AuditLogType2["TIMELINEENTRY_DELETED"] = "TIMELINEENTRY_DELETED";
    AuditLogType2["ETA_SET"] = "ETA_SET";
    AuditLogType2["ETA_DELETED"] = "ETA_DELETED";
    AuditLogType2["FLIGHT_ADDED"] = "FLIGHT_ADDED";
    AuditLogType2["FLIGHT_DELETED"] = "FLIGHT_DELETED";
    AuditLogType2["ADVANCED_TRACKING_ACTIVATED"] = "ADVANCED_TRACKING_ACTIVATED";
    AuditLogType2["ADVANCED_TRACKING_DEACTIVATED"] = "ADVANCED_TRACKING_DEACTIVATED";
    AuditLogType2["UNOSID_SET"] = "UNOSID_SET";
    AuditLogType2["UNOSID_DELETED"] = "UNOSID_DELETED";
    AuditLogType2["DESTINATION_SET"] = "DESTINATION_SET";
    AuditLogType2["DESTINATION_DELETED"] = "DESTINATION_DELETED";
    AuditLogType2["MANUAL_IMPORT_SESSION_LOGS"] = "MANUAL_IMPORT_SESSION_LOGS";
    return AuditLogType2;
}(AuditLogType || {});
// src/models/CannulationType.ts
var CannulationType = /* @__PURE__ */ function(CannulationType2) {
    CannulationType2["TANRP"] = "TANRP";
    CannulationType2["ANRP"] = "ANRP";
    return CannulationType2;
}(CannulationType || {});
// src/models/Destination.ts
var Destination = function Destination(param) {
    var isSessionOption = param.isSessionOption, isOrganizationOption = param.isOrganizationOption, name = param.name, handle = param.handle, organs = param.organs, types = param.types, owner = param.owner;
    _classCallCheck(this, Destination);
    this.isSessionOption = isSessionOption;
    this.isOrganizationOption = isOrganizationOption;
    this.name = name;
    this.handle = handle;
    this.organs = organs;
    this.types = types;
    this.owner = owner;
};
// src/models/DistanceUnit.ts
var DistanceUnit = /* @__PURE__ */ function(DistanceUnit3) {
    DistanceUnit3["METRIC"] = "metric";
    DistanceUnit3["IMPERIAL"] = "imperial";
    return DistanceUnit3;
}(DistanceUnit || {});
// src/models/Document.ts
var Document = function Document(param) {
    var id = param.id, name = param.name, sort = param.sort, storageRef = param.storageRef;
    _classCallCheck(this, Document);
    this.id = id;
    this.name = name;
    this.sort = sort;
    this.storageRef = storageRef;
};
// src/models/DonationType.ts
var DonationType = /* @__PURE__ */ function(DonationType2) {
    DonationType2["DBD"] = "DBD";
    DonationType2["DCD"] = "DCD";
    DonationType2["UNKNOWN"] = "UNKNOWN";
    return DonationType2;
}(DonationType || {});
// src/models/Flight.ts
var Flight = /*#__PURE__*/ function() {
    function Flight(param) {
        var flightId = param.flightId, ident = param.ident, state = param.state, progressPercent = param.progressPercent, dataTimestamp = param.dataTimestamp, arrivalDelay = param.arrivalDelay, actualArrival = param.actualArrival, actualDeparture = param.actualDeparture, departureDelay = param.departureDelay, estimatedDeparture = param.estimatedDeparture, estimatedArrival = param.estimatedArrival, plannedArrival = param.plannedArrival, plannedDeparture = param.plannedDeparture, origin = param.origin, destination = param.destination, destinationType = param.destinationType;
        _classCallCheck(this, Flight);
        this.flightId = flightId;
        this.ident = ident;
        this.state = state;
        this.progressPercent = progressPercent;
        this.dataTimestamp = dataTimestamp;
        this.arrivalDelay = arrivalDelay;
        this.actualArrival = actualArrival;
        this.actualDeparture = actualDeparture;
        this.departureDelay = departureDelay;
        this.estimatedDeparture = estimatedDeparture;
        this.estimatedArrival = estimatedArrival;
        this.plannedArrival = plannedArrival;
        this.plannedDeparture = plannedDeparture;
        this.origin = origin != null ? new Airport(origin) : void 0;
        this.destination = destination != null ? new Airport(destination) : void 0;
        this.destinationType = destinationType;
    }
    _createClass(Flight, [
        {
            key: "toJSON",
            value: function toJSON() {
                var _this_origin, _this_destination;
                return {
                    flightId: this.flightId,
                    ident: this.ident,
                    state: this.state,
                    progressPercent: this.progressPercent,
                    dataTimestamp: this.dataTimestamp,
                    arrivalDelay: this.arrivalDelay,
                    actualArrival: this.actualArrival,
                    actualDeparture: this.actualDeparture,
                    departureDelay: this.departureDelay,
                    estimatedDeparture: this.estimatedDeparture,
                    estimatedArrival: this.estimatedArrival,
                    plannedArrival: this.plannedArrival,
                    plannedDeparture: this.plannedDeparture,
                    origin: (_this_origin = this.origin) === null || _this_origin === void 0 ? void 0 : _this_origin.toJSON(),
                    destination: (_this_destination = this.destination) === null || _this_destination === void 0 ? void 0 : _this_destination.toJSON(),
                    destinationType: this.destinationType
                };
            }
        }
    ]);
    return Flight;
}();
// src/models/FlightDestinationType.ts
var FlightDestinationType = /* @__PURE__ */ function(FlightDestinationType2) {
    FlightDestinationType2["DONOR"] = "DONOR";
    FlightDestinationType2["RECIPIENT"] = "RECIPIENT";
    return FlightDestinationType2;
}(FlightDestinationType || {});
// src/models/FlightPosition.ts
var FlightPosition = function FlightPosition(param) {
    var altitude = param.altitude, flightId = param.flightId, groundspeed = param.groundspeed, heading = param.heading, latitude = param.latitude, longitude = param.longitude, timestamp = param.timestamp;
    _classCallCheck(this, FlightPosition);
    this.altitude = altitude;
    this.flightId = flightId;
    this.groundspeed = groundspeed;
    this.heading = heading;
    this.latitude = latitude;
    this.longitude = longitude;
    this.timestamp = timestamp;
};
// src/models/FlightState.ts
var FlightState = /* @__PURE__ */ function(FlightState2) {
    FlightState2["SCHEDULED"] = "SCHEDULED";
    FlightState2["IN_AIR"] = "IN_AIR";
    FlightState2["LANDED"] = "LANDED";
    FlightState2["CANCELLED"] = "CANCELLED";
    FlightState2["MANUAL"] = "MANUAL";
    FlightState2["UNKNOWN"] = "UNKNOWN";
    return FlightState2;
}(FlightState || {});
// src/models/Log.ts
var Log = function Log(param) {
    var log = param.log;
    _classCallCheck(this, Log);
    this.log = log;
};
// src/models/LoggerLocation.ts
var LoggerLocation = function LoggerLocation(param) {
    var latitude = param.latitude, longitude = param.longitude, _param_horizontalAccuracy = param.horizontalAccuracy, horizontalAccuracy = _param_horizontalAccuracy === void 0 ? -1 : _param_horizontalAccuracy, _param_verticalAccuracy = param.verticalAccuracy, verticalAccuracy = _param_verticalAccuracy === void 0 ? -1 : _param_verticalAccuracy, timestamp = param.timestamp;
    _classCallCheck(this, LoggerLocation);
    this.latitude = latitude;
    this.longitude = longitude;
    this.horizontalAccuracy = horizontalAccuracy;
    this.verticalAccuracy = verticalAccuracy;
    this.timestamp = timestamp;
};
// src/models/LungPositionType.ts
var LungPositionType = /* @__PURE__ */ function(LungPositionType2) {
    LungPositionType2["SUPINE"] = "SUPINE";
    LungPositionType2["PRONE"] = "PRONE";
    return LungPositionType2;
}(LungPositionType || {});
// src/models/Notification.ts
var Notification = function Notification(param) {
    var type = param.type, title = param.title, body = param.body, iconSrc = param.iconSrc, action = param.action, _param_isDismissable = param.isDismissable, isDismissable = _param_isDismissable === void 0 ? true : _param_isDismissable;
    _classCallCheck(this, Notification);
    this.type = type;
    this.title = title;
    this.body = body;
    this.iconSrc = iconSrc;
    this.action = action;
    this.isDismissable = isDismissable;
};
// src/models/Organization.ts
var Organization = function Organization(param) {
    var id = param.id, name = param.name, _param_adminIds = param.adminIds, adminIds = _param_adminIds === void 0 ? [] : _param_adminIds, _param_userIds = param.userIds, userIds = _param_userIds === void 0 ? [] : _param_userIds, status = param.status, handle = param.handle, organTypes = param.organTypes, _param_types = param.types, types = _param_types === void 0 ? [] : _param_types, address = param.address, addressComponents = param.addressComponents, location = param.location, country = param.country, logoFileName = param.logoFileName, logoUrl = param.logoUrl, _param_domains = param.domains, domains = _param_domains === void 0 ? [] : _param_domains, areDomainsWhitelisted = param.areDomainsWhitelisted, _param_isCorporate = param.isCorporate, isCorporate = _param_isCorporate === void 0 ? false : _param_isCorporate, createdAt = param.createdAt, updatedAt = param.updatedAt, validationStartedAt = param.validationStartedAt, activatedAt = param.activatedAt;
    _classCallCheck(this, Organization);
    this.id = id;
    this.name = name;
    this.adminIds = adminIds;
    this.userIds = userIds;
    this.status = status;
    this.handle = handle;
    this.organTypes = organTypes;
    this.types = types;
    this.address = address;
    this.addressComponents = addressComponents;
    this.location = location;
    this.country = country;
    this.logoFileName = logoFileName;
    this.logoUrl = logoUrl;
    this.domains = domains;
    this.areDomainsWhitelisted = areDomainsWhitelisted;
    this.isCorporate = isCorporate;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.validationStartedAt = validationStartedAt;
    this.activatedAt = activatedAt;
};
// src/models/OrganizationMember.ts
var OrganizationMember = /*#__PURE__*/ function() {
    function OrganizationMember(param) {
        var id = param.id, email = param.email, isEmailWhitelisted = param.isEmailWhitelisted, firstname = param.firstname, lastname = param.lastname, accessRole = param.accessRole, role = param.role, title = param.title, status = param.status, startOfEmployment = param.startOfEmployment, createdAt = param.createdAt, updatedAt = param.updatedAt, accessRequestedAt = param.accessRequestedAt, invitedAt = param.invitedAt, invitedBy = param.invitedBy, lastInvitedAt = param.lastInvitedAt, lastInvitedBy = param.lastInvitedBy, activatedAt = param.activatedAt, deactivatedAt = param.deactivatedAt, deactivatedBy = param.deactivatedBy, deactivationReason = param.deactivationReason, deactivationText = param.deactivationText;
        _classCallCheck(this, OrganizationMember);
        this.id = id;
        this.email = email;
        this.isEmailWhitelisted = isEmailWhitelisted;
        this.firstname = firstname;
        this.lastname = lastname;
        this.accessRole = accessRole;
        this.role = role;
        this.title = title;
        this.status = status;
        this.startOfEmployment = startOfEmployment;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.accessRequestedAt = accessRequestedAt;
        this.invitedAt = invitedAt;
        this.invitedBy = invitedBy;
        this.lastInvitedAt = lastInvitedAt;
        this.lastInvitedBy = lastInvitedBy;
        this.activatedAt = activatedAt;
        this.deactivatedAt = deactivatedAt;
        this.deactivatedBy = deactivatedBy;
        this.deactivationReason = deactivationReason;
        this.deactivationText = deactivationText;
    }
    _createClass(OrganizationMember, [
        {
            key: "fullname",
            get: function get() {
                var _this_firstname, _this_lastname;
                var name = [
                    (_this_firstname = this.firstname) !== null && _this_firstname !== void 0 ? _this_firstname : "",
                    (_this_lastname = this.lastname) !== null && _this_lastname !== void 0 ? _this_lastname : ""
                ];
                return name.join(" ");
            }
        }
    ]);
    return OrganizationMember;
}();
// src/models/OrganizationMemberAccessRole.ts
var OrganizationMemberAccessRole = /* @__PURE__ */ function(OrganizationMemberAccessRole2) {
    OrganizationMemberAccessRole2["ADMIN"] = "ADMIN";
    OrganizationMemberAccessRole2["VIEWER"] = "VIEWER";
    return OrganizationMemberAccessRole2;
}(OrganizationMemberAccessRole || {});
// src/models/OrganizationMemberDeactivationReason.ts
var OrganizationMemberDeactivationReason = /* @__PURE__ */ function(OrganizationMemberDeactivationReason2) {
    OrganizationMemberDeactivationReason2["LEFT_ORGANIZATION"] = "LEFT_ORGANIZATION";
    OrganizationMemberDeactivationReason2["DEACTIVATED"] = "DEACTIVATED";
    OrganizationMemberDeactivationReason2["ACCESS_REQUEST_DECLINED"] = "ACCESS_REQUEST_DECLINED";
    OrganizationMemberDeactivationReason2["USER_DOES_NOT_EXIST"] = "USER_DOES_NOT_EXIST";
    return OrganizationMemberDeactivationReason2;
}(OrganizationMemberDeactivationReason || {});
// src/models/OrganizationMemberRole.ts
var OrganizationMemberRole = function OrganizationMemberRole(params) {
    _classCallCheck(this, OrganizationMemberRole);
    this.id = params.id;
    this.isActive = params.isActive;
    this.locales = params.locales;
};
// src/models/OrganizationMemberStatus.ts
var OrganizationMemberStatus = /* @__PURE__ */ function(OrganizationMemberStatus2) {
    OrganizationMemberStatus2["PRESELECTED"] = "PRESELECTED";
    OrganizationMemberStatus2["ACCESS_REQUESTED"] = "ACCESS_REQUESTED";
    OrganizationMemberStatus2["CREATED"] = "CREATED";
    OrganizationMemberStatus2["INVITED"] = "INVITED";
    OrganizationMemberStatus2["ACTIVE"] = "ACTIVE";
    OrganizationMemberStatus2["INACTIVE"] = "INACTIVE";
    return OrganizationMemberStatus2;
}(OrganizationMemberStatus || {});
// src/models/OrganizationOption.ts
var OrganizationOption = function OrganizationOption(param) {
    var id = param.id, organizationId = param.organizationId, handle = param.handle, name = param.name, _param_organs = param.organs, organs = _param_organs === void 0 ? [] : _param_organs, _param_types = param.types, types = _param_types === void 0 ? [] : _param_types;
    _classCallCheck(this, OrganizationOption);
    this.id = id;
    this.organizationId = organizationId;
    this.handle = handle;
    this.name = name;
    this.organs = organs;
    this.types = types;
};
// src/models/OrganizationPreselectedMember.ts
var OrganizationPreselectedMember = /*#__PURE__*/ function(OrganizationMember) {
    _inherits(OrganizationPreselectedMember, OrganizationMember);
    var _super = _createSuper(OrganizationPreselectedMember);
    function OrganizationPreselectedMember(params) {
        _classCallCheck(this, OrganizationPreselectedMember);
        var _this;
        _this = _super.call(this, params);
        _this.isConfirmed = params.isConfirmed;
        _this.confirmedAt = params.confirmedAt;
        return _this;
    }
    return OrganizationPreselectedMember;
}(OrganizationMember);
// src/models/OrganizationStatus.ts
var OrganizationStatus = /* @__PURE__ */ function(OrganizationStatus2) {
    OrganizationStatus2["CREATE_REQUESTED"] = "CREATE_REQUESTED";
    OrganizationStatus2["CREATED"] = "CREATED";
    OrganizationStatus2["IN_VALIDATION"] = "IN_VALIDATION";
    OrganizationStatus2["ACTIVE"] = "ACTIVE";
    OrganizationStatus2["INACTIVE"] = "INACTIVE";
    return OrganizationStatus2;
}(OrganizationStatus || {});
// src/models/OrganizationType.ts
var OrganizationType = function OrganizationType(params) {
    _classCallCheck(this, OrganizationType);
    this.id = params.id;
    this.isActive = params.isActive;
    this.locales = params.locales;
};
// src/models/OrganizationUnregisteredInvite.ts
var OrganizationUnregisteredInvite = function OrganizationUnregisteredInvite(params) {
    _classCallCheck(this, OrganizationUnregisteredInvite);
    this.id = params.id;
    this.email = params.email;
    this.organizationId = params.organizationId;
    this.invitedBy = params.invitedBy;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
};
// src/models/OrganPositionType.ts
var OrganPositionType = /* @__PURE__ */ function(OrganPositionType2) {
    OrganPositionType2["LEFT"] = "LEFT";
    OrganPositionType2["RIGHT"] = "RIGHT";
    return OrganPositionType2;
}(OrganPositionType || {});
// src/models/OrganType.ts
var OrganType = /* @__PURE__ */ function(OrganType2) {
    OrganType2["HEART"] = "heart";
    OrganType2["LUNG"] = "lung";
    OrganType2["LIVER"] = "liver";
    OrganType2["KIDNEY"] = "kidney";
    OrganType2["PANCREAS"] = "pancreas";
    OrganType2["UNKNOWN"] = "unknown";
    return OrganType2;
}(OrganType || {});
// src/models/Product.ts
var Product = function Product(param) {
    var id = param.id, product = param.product, color = param.color, enabled = param.enabled, name = param.name, highlight = param.highlight, sort = param.sort, storageRef = param.storageRef;
    _classCallCheck(this, Product);
    this.id = id;
    this.product = product;
    this.color = color;
    this.enabled = enabled;
    this.name = name;
    this.highlight = highlight;
    this.sort = sort;
    this.storageRef = storageRef;
};
// src/models/ProductType.ts
var ProductType = /* @__PURE__ */ function(ProductType2) {
    ProductType2["SHERPAPAK"] = "sherpapak-cts";
    ProductType2["LUNGGUARD"] = "lungguard";
    ProductType2["BAROGUARD"] = "baroguard";
    ProductType2["LIVERGUARD"] = "liverguard";
    ProductType2["PANCREASPAK"] = "pancreaspak";
    ProductType2["KTS"] = "sherpapak-kts";
    ProductType2["VANTAGEPOINT"] = "vantage-point";
    ProductType2["UNKNOWN"] = "unknown";
    return ProductType2;
}(ProductType || {});
// src/models/Reading.ts
var import_translations = __toESM(require("@packages/translations"));
var import_utils = require("@packages/utils");
var Reading = /*#__PURE__*/ function() {
    function Reading(param) {
        var timestamp = param.timestamp, event = param.event, ambient = param.ambient, probe2 = param.probe, pressure3 = param.pressure, pumpVoltage = param.pumpVoltage;
        _classCallCheck(this, Reading);
        this.timestamp = timestamp;
        this.event = event;
        this.ambient = ambient;
        this.probe = probe2;
        this.pressure = pressure3;
        this.pumpVoltage = pumpVoltage;
    }
    _createClass(Reading, [
        {
            key: "isReading",
            value: function isReading() {
                return this.event === "reading";
            }
        },
        {
            key: "isStartedEvent",
            value: function isStartedEvent() {
                return this.event === "started";
            }
        },
        {
            key: "isStoppedEvent",
            value: function isStoppedEvent() {
                return this.event === "stopped";
            }
        },
        {
            key: "exportEvent",
            value: function exportEvent() {
                var t = import_translations.default.t;
                if (this.isReading()) {
                    return t("logger_reading");
                }
                return t("logger_event");
            }
        },
        {
            key: "exportValue",
            value: function exportValue() {
                return (0, import_utils.capitalize)(this.event);
            }
        },
        {
            key: "exportDescription",
            value: function exportDescription() {
                return this.event;
            }
        }
    ]);
    return Reading;
}();
// src/models/ReadingCompressed.ts
var ReadingCompressed = /*#__PURE__*/ function() {
    function ReadingCompressed(param) {
        var t = param.t, e = param.e, a = param.a, p = param.p, pr = param.pr, pv = param.pv;
        _classCallCheck(this, ReadingCompressed);
        this.t = t;
        this.e = e;
        this.a = a;
        this.p = p;
        this.pr = pr;
        this.pv = pv;
    }
    _createClass(ReadingCompressed, [
        {
            key: "toReading",
            value: function toReading() {
                return new Reading({
                    timestamp: this.t.toDate(),
                    event: this.e,
                    ambient: this.a,
                    probe: this.p,
                    pressure: this.pr,
                    pumpVoltage: this.pv
                });
            }
        }
    ]);
    return ReadingCompressed;
}();
// src/models/Session.ts
var import_utils2 = require("@packages/utils");
// src/models/SessionState.ts
var SessionState = /* @__PURE__ */ function(SessionState2) {
    SessionState2["CREATED"] = "CREATED";
    SessionState2["LOGGER_STARTED"] = "LOGGER_STARTED";
    SessionState2["LOGGER_STOPPED"] = "LOGGER_STOPPED";
    SessionState2["FINISHED"] = "FINISHED";
    SessionState2["UNKNOWN"] = "UNKNOWN";
    return SessionState2;
}(SessionState || {});
// src/models/Session.ts
var Session = /*#__PURE__*/ function() {
    function Session(params) {
        _classCallCheck(this, Session);
        this.id = params.id;
        this.device = params.device;
        this.appVersion = params.appVersion;
        this.os = params.os;
        this.osVersion = params.osVersion;
        this.loggerSerialNo = params.loggerSerialNo;
        this.loggerState = params.loggerState;
        this.joinKey = params.joinKey;
        this.admin = params.admin;
        this.destination = params.destination;
        this.createdAt = params.createdAt;
        this.createdBy = params.createdBy;
        this.createdByOrganization = params.createdByOrganization;
        this.userIds = params.userIds;
        this.finished = params.finished;
        this.lastTimelineEvent = params.lastTimelineEvent;
        this.donationType = params.donationType;
        this.product = params.product;
        this.organ = params.organ;
        this.pairedDeviceIdentifier = params.pairedDeviceIdentifier;
        this.sessionType = params.sessionType;
        this.endedAt = params.endedAt;
        this.eta = params.eta;
        this.etaSetBy = params.etaSetBy;
        this.loggerData = params.loggerData;
        this.location = params.location;
        this.reportData = params.reportData;
        this.metrics = params.metrics;
        this.metadata = params.metadata;
        this.ischemicTime = params.ischemicTime;
        this.loggerConnectedBy = params.loggerConnectedBy;
        this.flights = params.flights;
        this.flightPosition = params.flightPosition;
        this.advancedTrackerId = params.advancedTrackerId;
        this.advancedTracking = params.advancedTracking;
        this.unosId = params.unosId;
        var _params_organizationIds;
        this.organizationIds = (_params_organizationIds = params.organizationIds) !== null && _params_organizationIds !== void 0 ? _params_organizationIds : [];
        var _params_schemaVersion;
        this.schemaVersion = (_params_schemaVersion = params.schemaVersion) !== null && _params_schemaVersion !== void 0 ? _params_schemaVersion : 0;
    }
    _createClass(Session, [
        {
            key: "serialize",
            value: function serialize() {
                return JSON.parse(JSON.stringify(this));
            }
        },
        {
            key: "durationString",
            value: function durationString(options) {
                if (this.createdAt == null || this.endedAt == null) {
                    return "-";
                }
                var milliseconds = this.endedAt.getTime() - this.createdAt.getTime();
                return (0, import_utils2.millisecondsToTime)(milliseconds, options);
            }
        },
        {
            key: "durationInMilliseconds",
            value: function durationInMilliseconds() {
                if (this.createdAt == null || this.endedAt == null) {
                    return null;
                }
                return this.endedAt.getTime() - this.createdAt.getTime();
            }
        },
        {
            key: "getState",
            value: function getState() {
                if (this.isCreatedState()) {
                    return "CREATED" /* CREATED */ ;
                }
                if (this.isLoggerStartedState()) {
                    return "LOGGER_STARTED" /* LOGGER_STARTED */ ;
                }
                if (this.isLoggerStoppedState()) {
                    return "LOGGER_STOPPED" /* LOGGER_STOPPED */ ;
                }
                if (this.isFinishedState()) {
                    return "FINISHED" /* FINISHED */ ;
                }
                return "UNKNOWN" /* UNKNOWN */ ;
            }
        },
        {
            key: "isCreatedState",
            value: function isCreatedState() {
                return this.loggerState !== "STOPPED" && !this.finished && this.pairedDeviceIdentifier == null;
            }
        },
        {
            key: "isLoggerStartedState",
            value: function isLoggerStartedState() {
                return this.loggerState === "STARTED" && !this.finished;
            }
        },
        {
            key: "isLoggerStoppedState",
            value: function isLoggerStoppedState() {
                return this.loggerState === "STOPPED" && !this.finished;
            }
        },
        {
            key: "isFinishedState",
            value: function isFinishedState() {
                return this.finished;
            }
        }
    ]);
    return Session;
}();
// src/models/SessionIschemicTime.ts
var import_utils3 = require("@packages/utils");
var SessionIschemicTime = /*#__PURE__*/ function() {
    function SessionIschemicTime(param) {
        var startType = param.startType, endType = param.endType, startedAt = param.startedAt, endedAt = param.endedAt;
        _classCallCheck(this, SessionIschemicTime);
        this.startType = startType;
        this.endType = endType;
        this.startedAt = startedAt;
        this.endedAt = endedAt;
    }
    _createClass(SessionIschemicTime, [
        {
            key: "durationString",
            value: function durationString() {
                if (this.startedAt == null || this.endedAt == null) {
                    return "00:00:00";
                }
                var milliseconds = this.endedAt.getTime() - this.startedAt.getTime();
                return (0, import_utils3.millisecondsToPaddedTime)(milliseconds);
            }
        },
        {
            key: "durationInMilliseconds",
            value: function durationInMilliseconds() {
                if (this.startedAt == null || this.endedAt == null) {
                    return null;
                }
                return this.endedAt.getTime() - this.startedAt.getTime();
            }
        }
    ]);
    return SessionIschemicTime;
}();
// src/models/SessionMember.ts
var SessionMember = /*#__PURE__*/ function() {
    function SessionMember(param) {
        var id = param.id, email = param.email, firstname = param.firstname, lastname = param.lastname, organization = param.organization, organizationId = param.organizationId, organizationHandle = param.organizationHandle, organizationAccessRole = param.organizationAccessRole, joinedAt = param.joinedAt, muted = param.muted;
        _classCallCheck(this, SessionMember);
        this.id = id;
        this.email = email;
        this.firstname = firstname;
        this.lastname = lastname;
        this.organization = organization;
        this.organizationId = organizationId;
        this.organizationHandle = organizationHandle;
        this.organizationAccessRole = organizationAccessRole;
        this.joinedAt = joinedAt;
        this.muted = muted;
    }
    _createClass(SessionMember, [
        {
            key: "fullname",
            get: function get() {
                var _this_firstname, _this_lastname;
                var name = [
                    (_this_firstname = this.firstname) !== null && _this_firstname !== void 0 ? _this_firstname : "",
                    (_this_lastname = this.lastname) !== null && _this_lastname !== void 0 ? _this_lastname : ""
                ];
                return name.join(" ");
            }
        }
    ]);
    return SessionMember;
}();
// src/models/SessionMetadata.ts
var SessionMetadata = function SessionMetadata(param) {
    var stopReminderSent = param.stopReminderSent, forceStopAfter48Hours = param.forceStopAfter48Hours, reportSentTo = param.reportSentTo;
    _classCallCheck(this, SessionMetadata);
    this.stopReminderSent = stopReminderSent;
    this.forceStopAfter48Hours = forceStopAfter48Hours;
    this.reportSentTo = reportSentTo;
};
// src/models/SessionMetrics.ts
var SessionMetrics = function SessionMetrics(param) {
    var memberCount = param.memberCount, timelineCount = param.timelineCount, messageCount = param.messageCount;
    _classCallCheck(this, SessionMetrics);
    this.memberCount = memberCount;
    this.timelineCount = timelineCount;
    this.messageCount = messageCount;
};
// src/models/SessionReportData.ts
var SessionReportData = function SessionReportData(params) {
    _classCallCheck(this, SessionReportData);
    this.ambientAverage = params.ambientAverage;
    this.ambientMaximum = params.ambientMaximum;
    this.ambientMinimum = params.ambientMinimum;
    this.probeAverage = params.probeAverage;
    this.probeMaximum = params.probeMaximum;
    this.probeMinimum = params.probeMinimum;
    this.pressureAverage = params.pressureAverage;
    this.pressureMaximum = params.pressureMaximum;
    this.pressureMinimum = params.pressureMinimum;
    this.pumpVoltageStart = params.pumpVoltageStart;
    this.pumpVoltageEnd = params.pumpVoltageEnd;
    this.distance = params.distance;
    this.readingsCount = params.readingsCount;
    this.loggerStartedAt = params.loggerStartedAt;
    this.loggerStoppedAt = params.loggerStoppedAt;
    this.loggingDurationMillis = params.loggingDurationMillis;
    this.firstReading = params.firstReading;
    this.lastReading = params.lastReading;
};
// src/models/SessionType.ts
var SessionType = /* @__PURE__ */ function(SessionType2) {
    SessionType2["CLINICAL"] = "CLINICAL";
    SessionType2["TRAINING"] = "TRAINING";
    SessionType2["UNKNOWN"] = "UNKNOWN";
    return SessionType2;
}(SessionType || {});
// src/models/TimelineEntry.ts
var import_translations8 = __toESM(require("@packages/translations"));
// src/modelUtils/AuditLogTypeUtil.ts
var AuditLogTypeUtil = /*#__PURE__*/ function() {
    function AuditLogTypeUtil() {
        _classCallCheck(this, AuditLogTypeUtil);
    }
    _createClass(AuditLogTypeUtil, null, [
        {
            key: "toUserUIString",
            value: function toUserUIString(type) {
                switch(type){
                    case "SESSION_CREATED" /* SESSION_CREATED */ :
                        return "created a new session";
                    case "SESSION_JOINED" /* SESSION_JOINED */ :
                        return "joined the session";
                    case "SESSION_LEFT" /* SESSION_LEFT */ :
                        return "left the session";
                    case "SESSION_STOPPED" /* SESSION_STOPPED */ :
                        return "stopped the session";
                    case "LOGGER_STARTED" /* LOGGER_STARTED */ :
                        return "started the logger";
                    case "LOGGER_CONNECTED" /* LOGGER_CONNECTED */ :
                        return "connected the logger";
                    case "LOGGER_DISCONNECTED" /* LOGGER_DISCONNECTED */ :
                        return "disconnected the logger";
                    case "LOGGER_STOPPED" /* LOGGER_STOPPED */ :
                        return "stopped the logger";
                    case "TIMELINEENTRY_ADDED" /* TIMELINEENTRY_ADDED */ :
                        return "added a new timeline entry";
                    case "TIMELINEENTRY_UPDATED" /* TIMELINEENTRY_UPDATED */ :
                        return "updated a timeline entry";
                    case "TIMELINEENTRY_DELETED" /* TIMELINEENTRY_DELETED */ :
                        return "deleted a timeline entry";
                    case "ETA_SET" /* ETA_SET */ :
                        return "set ETA";
                    case "ETA_DELETED" /* ETA_DELETED */ :
                        return "deleted ETA";
                    case "FLIGHT_ADDED" /* FLIGHT_ADDED */ :
                        return "added flight";
                    case "FLIGHT_DELETED" /* FLIGHT_DELETED */ :
                        return "deleted flight";
                    case "ADVANCED_TRACKING_ACTIVATED" /* ADVANCED_TRACKING_ACTIVATED */ :
                        return "activated VantagePoint tracking";
                    case "ADVANCED_TRACKING_DEACTIVATED" /* ADVANCED_TRACKING_DEACTIVATED */ :
                        return "deactivated VantagePoint tracking";
                    case "UNOSID_SET" /* UNOSID_SET */ :
                        return "set UNOS ID";
                    case "UNOSID_DELETED" /* UNOSID_DELETED */ :
                        return "deleted UNOS ID";
                    case "DESTINATION_SET" /* DESTINATION_SET */ :
                        return "set destination";
                    case "DESTINATION_DELETED" /* DESTINATION_DELETED */ :
                        return "deleted destination";
                    case "MANUAL_IMPORT_SESSION_LOGS" /* MANUAL_IMPORT_SESSION_LOGS */ :
                        return "manually imported session logs";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return AuditLogTypeUtil;
}();
// src/modelUtils/CannulationTypeUtil.ts
var CannulationTypeUtil = /*#__PURE__*/ function() {
    function CannulationTypeUtil() {
        _classCallCheck(this, CannulationTypeUtil);
    }
    _createClass(CannulationTypeUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(type) {
                switch(type){
                    case "TANRP" /* TANRP */ :
                        return "TA-NRP";
                    case "ANRP" /* ANRP */ :
                        return "A-NRP";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return CannulationTypeUtil;
}();
// src/modelUtils/DonationTypeUtil.ts
var import_constants = require("@packages/constants");
var import_translations2 = __toESM(require("@packages/translations"));
var DonationTypeUtil = /*#__PURE__*/ function() {
    function DonationTypeUtil() {
        _classCallCheck(this, DonationTypeUtil);
    }
    _createClass(DonationTypeUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(mode) {
                var t = import_translations2.default.t;
                switch(mode){
                    case "DBD" /* DBD */ :
                        return t("dbd");
                    case "DCD" /* DCD */ :
                        return t("dcd");
                    default:
                        return t("unknown");
                }
            }
        },
        {
            key: "colors",
            value: function colors(type) {
                switch(type){
                    case "DBD" /* DBD */ :
                        return import_constants.Colors.COLOR_DONATION_TYPE_PRIMARY;
                    case "DCD" /* DCD */ :
                        return import_constants.Colors.COLOR_DONATION_TYPE_PRIMARY_LIGHT;
                    default:
                        return import_constants.Colors.COLOR_UNKNOWN_PRIMARY_LIGHT;
                }
            }
        }
    ]);
    return DonationTypeUtil;
}();
// src/modelUtils/FlightStateUtil.ts
var FlightStateUtil = /*#__PURE__*/ function() {
    function FlightStateUtil() {
        _classCallCheck(this, FlightStateUtil);
    }
    _createClass(FlightStateUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(state) {
                switch(state){
                    case "SCHEDULED" /* SCHEDULED */ :
                        return "SCHEDULED";
                    case "IN_AIR" /* IN_AIR */ :
                        return "IN AIR";
                    case "LANDED" /* LANDED */ :
                        return "LANDED";
                    case "CANCELLED" /* CANCELLED */ :
                        return "CANCELLED";
                    default:
                        return "UNKNOWN";
                }
            }
        }
    ]);
    return FlightStateUtil;
}();
// src/modelUtils/NotificationUtil.ts
var import_constants3 = require("@packages/constants");
var import_translations5 = __toESM(require("@packages/translations"));
// src/modelUtils/ProductUtil.ts
var import_assets = require("@packages/assets");
var import_constants2 = require("@packages/constants");
var import_translations3 = __toESM(require("@packages/translations"));
var ProductUtil = /*#__PURE__*/ function() {
    function ProductUtil() {
        _classCallCheck(this, ProductUtil);
    }
    _createClass(ProductUtil, null, [
        {
            key: "organTypeFromProduct",
            value: function organTypeFromProduct(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return "lung" /* LUNG */ ;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return "lung" /* LUNG */ ;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return "liver" /* LIVER */ ;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return "pancreas" /* PANCREAS */ ;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return "kidney" /* KIDNEY */ ;
                }
                return "heart" /* HEART */ ;
            }
        },
        {
            key: "organString",
            value: function organString(product) {
                var t = import_translations3.default.t;
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return t("organ_lung");
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return t("organ_lung");
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return t("organ_liver");
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return t("organ_pancreas");
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return t("organ_kidney");
                }
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return t("unknown");
                }
                return t("organ_heart");
            }
        },
        {
            key: "toHeading",
            value: function toHeading(product) {
                var t = import_translations3.default.t;
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return t("lungguard_product_heading");
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return t("baroguard_product_heading");
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return t("liverguard_product_heading");
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return t("pancreaspak_product_heading");
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return t("kts_product_heading");
                }
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return t("vantage_point_product_heading");
                }
                return t("sherpapak_product_heading");
            }
        },
        {
            key: "fromId",
            value: function fromId(id) {
                switch(id){
                    case "sherpapak-cts":
                        return "sherpapak-cts" /* SHERPAPAK */ ;
                    case "lungguard":
                        return "lungguard" /* LUNGGUARD */ ;
                    case "baroguard":
                        return "baroguard" /* BAROGUARD */ ;
                    case "liverguard":
                        return "liverguard" /* LIVERGUARD */ ;
                    case "pancreaspak":
                        return "pancreaspak" /* PANCREASPAK */ ;
                    case "sherpapak-kts":
                        return "sherpapak-kts" /* KTS */ ;
                    case "vantage-point":
                        return "vantage-point" /* VANTAGEPOINT */ ;
                    default:
                        return "sherpapak-cts" /* SHERPAPAK */ ;
                }
            }
        },
        {
            key: "toId",
            value: function toId(product) {
                return product !== null && product !== void 0 ? product : "sherpapak-cts" /* SHERPAPAK */ ;
            }
        },
        {
            key: "iconPath",
            value: function iconPath(product) {
                var background = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return background ? import_assets.Assets.organs.lungIconBgPng : import_assets.Assets.organs.lungIconPng;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return background ? import_assets.Assets.organs.lungIconBgPng : import_assets.Assets.organs.lungIconPng;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return background ? import_assets.Assets.organs.liverIconBgPng : import_assets.Assets.organs.liverIconPng;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return background ? import_assets.Assets.organs.pancreasIconBgPng : import_assets.Assets.organs.pancreasIconPng;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return background ? import_assets.Assets.organs.kidneyIconBgPng : import_assets.Assets.organs.kidneyIconPng;
                }
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return background ? import_assets.Assets.products.vantagepointPng : import_assets.Assets.products.vantagepointPng;
                }
                return background ? import_assets.Assets.organs.heartIconBgPng : import_assets.Assets.organs.heartIconPng;
            }
        },
        {
            key: "markerSvg",
            value: function markerSvg(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_assets.Assets.markers.lung;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_assets.Assets.markers.lung;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_assets.Assets.markers.liver;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_assets.Assets.markers.pancreas;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_assets.Assets.markers.kidney;
                }
                return import_assets.Assets.markers.heart;
            }
        },
        {
            key: "flightMarkerSvg",
            value: function flightMarkerSvg(product) {
                var heading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
                return this.matchHeading(product, heading);
            }
        },
        {
            key: "matchHeading",
            value: function matchHeading(product) {
                var heading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return this.tiveMarkerSvg(product);
                }
                var _obj;
                var MARKER_MAP = (_obj = {}, _defineProperty(_obj, "sherpapak-cts" /* SHERPAPAK */ , [
                    import_assets.Assets.markers.heartMarkerFlightSvg0,
                    import_assets.Assets.markers.heartMarkerFlightSvg45,
                    import_assets.Assets.markers.heartMarkerFlightSvg90,
                    import_assets.Assets.markers.heartMarkerFlightSvg135,
                    import_assets.Assets.markers.heartMarkerFlightSvg180,
                    import_assets.Assets.markers.heartMarkerFlightSvg225,
                    import_assets.Assets.markers.heartMarkerFlightSvg270,
                    import_assets.Assets.markers.heartMarkerFlightSvg315,
                    import_assets.Assets.markers.heartMarkerFlightSvg360
                ]), _defineProperty(_obj, "lungguard" /* LUNGGUARD */ , [
                    import_assets.Assets.markers.lungMarkerFlightSvg0,
                    import_assets.Assets.markers.lungMarkerFlightSvg45,
                    import_assets.Assets.markers.lungMarkerFlightSvg90,
                    import_assets.Assets.markers.lungMarkerFlightSvg135,
                    import_assets.Assets.markers.lungMarkerFlightSvg180,
                    import_assets.Assets.markers.lungMarkerFlightSvg225,
                    import_assets.Assets.markers.lungMarkerFlightSvg270,
                    import_assets.Assets.markers.lungMarkerFlightSvg315,
                    import_assets.Assets.markers.lungMarkerFlightSvg360
                ]), _defineProperty(_obj, "baroguard" /* BAROGUARD */ , [
                    import_assets.Assets.markers.lungMarkerFlightSvg0,
                    import_assets.Assets.markers.lungMarkerFlightSvg45,
                    import_assets.Assets.markers.lungMarkerFlightSvg90,
                    import_assets.Assets.markers.lungMarkerFlightSvg135,
                    import_assets.Assets.markers.lungMarkerFlightSvg180,
                    import_assets.Assets.markers.lungMarkerFlightSvg225,
                    import_assets.Assets.markers.lungMarkerFlightSvg270,
                    import_assets.Assets.markers.lungMarkerFlightSvg315,
                    import_assets.Assets.markers.lungMarkerFlightSvg360
                ]), _defineProperty(_obj, "liverguard" /* LIVERGUARD */ , [
                    import_assets.Assets.markers.liverMarkerFlightSvg0,
                    import_assets.Assets.markers.liverMarkerFlightSvg45,
                    import_assets.Assets.markers.liverMarkerFlightSvg90,
                    import_assets.Assets.markers.liverMarkerFlightSvg135,
                    import_assets.Assets.markers.liverMarkerFlightSvg180,
                    import_assets.Assets.markers.liverMarkerFlightSvg225,
                    import_assets.Assets.markers.liverMarkerFlightSvg270,
                    import_assets.Assets.markers.liverMarkerFlightSvg315,
                    import_assets.Assets.markers.liverMarkerFlightSvg360
                ]), _defineProperty(_obj, "pancreaspak" /* PANCREASPAK */ , [
                    import_assets.Assets.markers.pancreasMarkerFlightSvg0,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg45,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg90,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg135,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg180,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg225,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg270,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg315,
                    import_assets.Assets.markers.pancreasMarkerFlightSvg360
                ]), _defineProperty(_obj, "sherpapak-kts" /* KTS */ , [
                    import_assets.Assets.markers.kidneyMarkerFlightSvg0,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg45,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg90,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg135,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg180,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg225,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg270,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg315,
                    import_assets.Assets.markers.kidneyMarkerFlightSvg360
                ]), _defineProperty(_obj, "unknown" /* UNKNOWN */ , [
                    import_assets.Assets.markers.heartMarkerFlightSvg0,
                    import_assets.Assets.markers.heartMarkerFlightSvg45,
                    import_assets.Assets.markers.heartMarkerFlightSvg90,
                    import_assets.Assets.markers.heartMarkerFlightSvg135,
                    import_assets.Assets.markers.heartMarkerFlightSvg180,
                    import_assets.Assets.markers.heartMarkerFlightSvg225,
                    import_assets.Assets.markers.heartMarkerFlightSvg270,
                    import_assets.Assets.markers.heartMarkerFlightSvg315,
                    import_assets.Assets.markers.heartMarkerFlightSvg360
                ]), _obj);
                var INDEX_MAP = [
                    0,
                    45,
                    90,
                    135,
                    180,
                    225,
                    270,
                    315,
                    360
                ];
                var closest = INDEX_MAP.reduce(function(prev, curr) {
                    return Math.abs(curr - heading) < Math.abs(prev - heading) ? curr : prev;
                });
                var index = INDEX_MAP.findIndex(function(elem) {
                    return elem === closest;
                });
                return MARKER_MAP[product !== null && product !== void 0 ? product : "sherpapak-cts" /* SHERPAPAK */ ][index];
            }
        },
        {
            key: "tiveMarkerSvg",
            value: function tiveMarkerSvg(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_assets.Assets.markers.lungMarkerTiveSvg;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_assets.Assets.markers.lungMarkerTiveSvg;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_assets.Assets.markers.liverMarkerTiveSvg;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_assets.Assets.markers.pancreasMarkerTiveSvg;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_assets.Assets.markers.kidneyMarkerTiveSvg;
                }
                return import_assets.Assets.markers.heartMarkerTiveSvg;
            }
        },
        {
            key: "imagePath",
            value: function imagePath(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_assets.Assets.products.lungguardPng;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_assets.Assets.products.baroguardPng;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_assets.Assets.products.liverguardPng;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_assets.Assets.products.pancreaspakPng;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_assets.Assets.products.ktsPng;
                }
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return import_assets.Assets.products.vantagepointPng;
                }
                return import_assets.Assets.products.sherpapakPng;
            }
        },
        {
            key: "colors",
            value: function colors(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_LUNGGUARD_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_LUNGGUARD_PRIMARY_LIGHT
                    };
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_LUNGGUARD_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_LUNGGUARD_PRIMARY_LIGHT
                    };
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_LIVERGUARD_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_LIVERGUARD_PRIMARY_LIGHT
                    };
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_PANCREASPAK_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_PANCREASPAK_PRIMARY_LIGHT
                    };
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_KTS_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_KTS_PRIMARY_LIGHT
                    };
                }
                if (product === "vantage-point" /* VANTAGEPOINT */ ) {
                    return {
                        primary: import_constants2.Colors.COLOR_VANTAGEPOINT_PRIMARY,
                        primaryLight: import_constants2.Colors.COLOR_VANTAGEPOINT_PRIMARY_LIGHT
                    };
                }
                return {
                    primary: import_constants2.Colors.COLOR_SHERPAPAK_PRIMARY,
                    primaryLight: import_constants2.Colors.COLOR_SHERPAPAK_PRIMARY_LIGHT
                };
            }
        },
        {
            key: "cssClass",
            value: function cssClass(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return "lungguard";
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return "baroguard";
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return "liverguard";
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return "pancreaspak";
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return "kts";
                }
                return "sherpapak";
            }
        },
        {
            key: "imageUrl",
            value: function imageUrl(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_constants2.ImageUrls.LUNGGUARD_PUBLIC_IMAGE_URL;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_constants2.ImageUrls.BAROGUARD_PUBLIC_IMAGE_URL;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_constants2.ImageUrls.LIVERGUARD_PUBLIC_IMAGE_URL;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_constants2.ImageUrls.PANCREASPAK_PUBLIC_IMAGE_URL;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_constants2.ImageUrls.KTS_PUBLIC_IMAGE_URL;
                }
                return import_constants2.ImageUrls.SHERPAPAK_PUBLIC_IMAGE_URL;
            }
        },
        {
            key: "sessionDetailsIcons",
            value: function sessionDetailsIcons(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_constants2.ImageUrls.LUNGGUARD_PUBLIC_SESSION_DETAILS_ICONS;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_constants2.ImageUrls.LUNGGUARD_PUBLIC_SESSION_DETAILS_ICONS;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_constants2.ImageUrls.LIVERGUARD_PUBLIC_SESSION_DETAILS_ICONS;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_constants2.ImageUrls.PANCREASPAK_PUBLIC_SESSION_DETAILS_ICONS;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_constants2.ImageUrls.KTS_PUBLIC_SESSION_DETAILS_ICONS;
                }
                return import_constants2.ImageUrls.SHERPAPAK_PUBLIC_SESSION_DETAILS_ICONS;
            }
        },
        {
            key: "disclaimerImages",
            value: function disclaimerImages(product) {
                if (product === "lungguard" /* LUNGGUARD */ ) {
                    return import_constants2.ImageUrls.LUNGGUARD_PUBLIC_DISCLAIMER_IMAGES;
                }
                if (product === "baroguard" /* BAROGUARD */ ) {
                    return import_constants2.ImageUrls.BAROGUARD_PUBLIC_DISCLAIMER_IMAGES;
                }
                if (product === "liverguard" /* LIVERGUARD */ ) {
                    return import_constants2.ImageUrls.LIVERGUARD_PUBLIC_DISCLAIMER_IMAGES;
                }
                if (product === "pancreaspak" /* PANCREASPAK */ ) {
                    return import_constants2.ImageUrls.PANCREASPAK_PUBLIC_DISCLAIMER_IMAGES;
                }
                if (product === "sherpapak-kts" /* KTS */ ) {
                    return import_constants2.ImageUrls.KTS_PUBLIC_DISCLAIMER_IMAGES;
                }
                return import_constants2.ImageUrls.SHERPAPAK_PUBLIC_DISCLAIMER_IMAGES;
            }
        }
    ]);
    return ProductUtil;
}();
// src/modelUtils/TimelineEntryTypeUtil.ts
var import_translations4 = __toESM(require("@packages/translations"));
// src/modelUtils/LungPositionTypeUtil.ts
var LungPositionTypeUtil = /*#__PURE__*/ function() {
    function LungPositionTypeUtil() {
        _classCallCheck(this, LungPositionTypeUtil);
    }
    _createClass(LungPositionTypeUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(type) {
                switch(type){
                    case "SUPINE" /* SUPINE */ :
                        return "Supine";
                    case "PRONE" /* PRONE */ :
                        return "Prone";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return LungPositionTypeUtil;
}();
// src/modelUtils/TimelineEntryTypeUtil.ts
var TimelineEntryTypeUtil = /*#__PURE__*/ function() {
    function TimelineEntryTypeUtil() {
        _classCallCheck(this, TimelineEntryTypeUtil);
    }
    _createClass(TimelineEntryTypeUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(type, product, annotations) {
                var t = import_translations4.default.t;
                var transportDeviceName = ProductUtil.toHeading(product);
                var lungPositionTypeAnnotation = product === "baroguard" /* BAROGUARD */  && (annotations === null || annotations === void 0 ? void 0 : annotations.position) != null ? " - ".concat(LungPositionTypeUtil.toUIString(annotations.position)) : "";
                var cannulationTypeAnnotation = (annotations === null || annotations === void 0 ? void 0 : annotations.cannulation) != null ? " - ".concat(CannulationTypeUtil.toUIString(annotations.cannulation)) : "";
                switch(type){
                    case "START_SESSION" /* START_SESSION */ :
                        return t("session_update_start_session");
                    case "LEAVE_TX_CENTER" /* LEAVE_TX_CENTER */ :
                        return t("session_update_leave_tx_center");
                    case "PLANE_DEPARTURE_RECIPIENT" /* PLANE_DEPARTURE_RECIPIENT */ :
                        return t("session_update_plane_departure_recipient");
                    case "PLANE_ARRIVAL_DONOR" /* PLANE_ARRIVAL_DONOR */ :
                        return t("session_update_plane_arrival_donor");
                    case "ARRIVAL_AT_DONOR" /* ARRIVAL_AT_DONOR */ :
                        return t("session_update_arrival_at_donor");
                    case "DONOR_IN_ROOM" /* DONOR_IN_ROOM */ :
                        return t("session_update_donor_in_room");
                    case "TIME_TO_INCISION" /* TIME_TO_INCISION */ :
                        return t("session_update_time_to_incision");
                    case "HEPARIN_ADMINISTERED" /* HEPARIN_ADMINISTERED */ :
                        return t("session_update_heparin_administered");
                    case "CROSSCLAMP_AT_DONOR" /* CROSSCLAMP_AT_DONOR */ :
                        return t("session_update_crossclamp_at_donor");
                    case "ORGAN_REMOVAL" /* ORGAN_REMOVAL */ :
                        return t("session_update_organ_removal");
                    case "START_LOGGER" /* START_LOGGER */ :
                        return t("session_update_start_logger");
                    case "LEAVE_DONOR" /* LEAVE_DONOR */ :
                        return t("session_update_leave_donor");
                    case "PLANE_DEPARTURE_DONOR" /* PLANE_DEPARTURE_DONOR */ :
                        return t("session_update_plane_departure_donor");
                    case "PLANE_ARRIVAL_RECIPIENT" /* PLANE_ARRIVAL_RECIPIENT */ :
                        return t("session_update_plane_arrival_recipient");
                    case "ARRIVE_AT_RECIPIENT" /* ARRIVE_AT_RECIPIENT */ :
                        return t("session_update_arrive_at_recipient");
                    case "STOP_LOGGER" /* STOP_LOGGER */ :
                        return t("session_update_stop_logger");
                    case "CROSSCLAMP_AT_RECIPIENT" /* CROSSCLAMP_AT_RECIPIENT */ :
                        return t("session_update_crossclamp_at_recipient");
                    case "STOP_SESSION" /* STOP_SESSION */ :
                        return t("session_update_stop_session");
                    case "ORGAN_ACCEPTED" /* ORGAN_ACCEPTED */ :
                        return t("session_update_organ_accepted");
                    case "ORGAN_DECLINED" /* ORGAN_DECLINED */ :
                        return t("session_update_organ_declined");
                    case "TIME_OF_WITHDRAWAL" /* TIME_OF_WITHDRAWAL */ :
                        return t("session_update_time_of_withdrawal");
                    case "WARM_ISCHEMIC_TIME_START" /* WARM_ISCHEMIC_TIME_START */ :
                        return t("session_update_warm_ischemic_time_start");
                    case "OBSERVATION_PERIOD_START" /* OBSERVATION_PERIOD_START */ :
                        return t("session_update_observation_period_start");
                    case "TIME_OF_DEATH" /* TIME_OF_DEATH */ :
                        return t("session_update_time_of_death");
                    case "ORGAN_REMOVAL_LUNG" /* ORGAN_REMOVAL_LUNG */ :
                        return t("session_update_organ_removal_lung");
                    case "ORGAN_REMOVAL_LIVER" /* ORGAN_REMOVAL_LIVER */ :
                        return t("session_update_organ_removal_liver");
                    case "ORGAN_REMOVAL_PANCREAS" /* ORGAN_REMOVAL_PANCREAS */ :
                        return t("session_update_organ_removal_pancreas");
                    case "PANCREAS_PLACED_IN_PANCREASPAK" /* PANCREAS_PLACED_IN_PANCREASPAK */ :
                        return t("session_update_pancreas_placed_in_pancreaspak");
                    case "PANCREAS_REMOVED_FROM_PANCREASPAK" /* PANCREAS_REMOVED_FROM_PANCREASPAK */ :
                        return t("session_update_pancreas_removed_from_pancreaspak");
                    case "HEART_REMOVED_FROM_SHERPAPAK" /* HEART_REMOVED_FROM_SHERPAPAK */ :
                        return t("session_update_heart_removed_from_sherpapak");
                    case "HEART_PLACED_IN_SHERPAPAK" /* HEART_PLACED_IN_SHERPAPAK */ :
                        return t("session_update_heart_placed_in_sherpapak");
                    case "LIVER_REMOVED_FROM_LIVERGUARD" /* LIVER_REMOVED_FROM_LIVERGUARD */ :
                        return t("session_update_liver_removed_from_liverguard");
                    case "LIVER_PLACED_IN_LIVERGUARD" /* LIVER_PLACED_IN_LIVERGUARD */ :
                        return t("session_update_liver_placed_in_liverguard");
                    case "LUNGS_REMOVED_FROM_LUNGGUARD" /* LUNGS_REMOVED_FROM_LUNGGUARD */ :
                        return t("session_update_lungs_removed_from_lungguard", {
                            transportDeviceName: transportDeviceName
                        });
                    case "LUNG_PLACED_IN_LUNGGUARD" /* LUNG_PLACED_IN_LUNGGUARD */ :
                        return "".concat(t("session_update_lung_placed_in_lungguard", {
                            transportDeviceName: transportDeviceName
                        })).concat(lungPositionTypeAnnotation);
                    case "LEFT_LUNG_REMOVED_FROM_LUNGGUARD" /* LEFT_LUNG_REMOVED_FROM_LUNGGUARD */ :
                        return t("session_update_left_lung_removed_from_lungguard", {
                            transportDeviceName: transportDeviceName
                        });
                    case "RIGHT_LUNG_REMOVED_FROM_LUNGGUARD" /* RIGHT_LUNG_REMOVED_FROM_LUNGGUARD */ :
                        return t("session_update_right_lung_removed_from_lungguard", {
                            transportDeviceName: transportDeviceName
                        });
                    case "LEFT_LUNG_ANASTOMOSIS_COMPLETE" /* LEFT_LUNG_ANASTOMOSIS_COMPLETE */ :
                        return t("session_update_left_lung_anastomosis_complete");
                    case "RIGHT_LUNG_ANASTOMOSIS_COMPLETE" /* RIGHT_LUNG_ANASTOMOSIS_COMPLETE */ :
                        return t("session_update_right_lung_anastomosis_complete");
                    case "PORTAL_REPERFUSION" /* PORTAL_REPERFUSION */ :
                        return t("session_update_portal_reperfusion");
                    case "ARTERIAL_REPERFUSION" /* ARTERIAL_REPERFUSION */ :
                        return t("session_update_arterial_reperfusion");
                    case "PERFUSION_START" /* PERFUSION_START */ :
                        return t("session_update_perfusion_start");
                    case "PERFUSION_STOP" /* PERFUSION_STOP */ :
                        return t("session_update_perfusion_stop");
                    case "RECIPIENT_LEFT_LUNG_OFF_CLAMP" /* RECIPIENT_LEFT_LUNG_OFF_CLAMP */ :
                        return t("session_update_recipient_left_lung_off_clamp");
                    case "RECIPIENT_RIGHT_LUNG_OFF_CLAMP" /* RECIPIENT_RIGHT_LUNG_OFF_CLAMP */ :
                        return t("session_update_recipient_right_lung_off_clamp");
                    case "KIDNEY_DONOR_FINAL_BLOOD_UREA_NITROGEN" /* KIDNEY_DONOR_FINAL_BLOOD_UREA_NITROGEN */ :
                        return t("session_update_donor_final_blood_urea_nitrogen");
                    case "KIDNEY_DONOR_FINAL_SERUM_CREATININE" /* KIDNEY_DONOR_FINAL_SERUM_CREATININE */ :
                        return t("session_update_donor_final_serum_creatinine");
                    case "KIDNEY_DONOR_KIDNEY_DONOR_PROFILE_INDEX" /* KIDNEY_DONOR_KIDNEY_DONOR_PROFILE_INDEX */ :
                        return t("session_update_donor_kidney_donor_profile_index");
                    case "KIDNEY_WITHDRAWAL_OF_SUPPORT" /* KIDNEY_WITHDRAWAL_OF_SUPPORT */ :
                        return t("session_update_withdrawal_support");
                    case "KIDNEY_START_AGONAL_PHASE" /* KIDNEY_START_AGONAL_PHASE */ :
                        return t("session_update_start_agonal_phase");
                    case "KIDNEY_START_FLUSH" /* KIDNEY_START_FLUSH */ :
                        return t("session_update_start_flush");
                    case "KIDNEY_X_CLAMP" /* KIDNEY_X_CLAMP */ :
                        return t("session_update_x_clamp");
                    case "RIGHT_KIDNEY_REMOVAL" /* RIGHT_KIDNEY_REMOVAL */ :
                        return t("session_update_right_kidney_removal");
                    case "LEFT_KIDNEY_REMOVAL" /* LEFT_KIDNEY_REMOVAL */ :
                        return t("session_update_left_kidney_removal");
                    case "RIGHT_KIDNEY_PLACED_INTO_STORAGE" /* RIGHT_KIDNEY_PLACED_INTO_STORAGE */ :
                        return t("session_update_right_kidney_placed_in_device", {
                            transportDeviceName: transportDeviceName
                        });
                    case "LEFT_KIDNEY_PLACED_INTO_STORAGE" /* LEFT_KIDNEY_PLACED_INTO_STORAGE */ :
                        return t("session_update_left_kidney_placed_in_device", {
                            transportDeviceName: transportDeviceName
                        });
                    case "RIGHT_KIDNEY_ACCEPTED" /* RIGHT_KIDNEY_ACCEPTED */ :
                        return t("session_update_right_kidney_accepted");
                    case "RIGHT_KIDNEY_DECLINED" /* RIGHT_KIDNEY_DECLINED */ :
                        return t("session_update_right_kidney_declined");
                    case "LEFT_KIDNEY_ACCEPTED" /* LEFT_KIDNEY_ACCEPTED */ :
                        return t("session_update_left_kidney_accepted");
                    case "LEFT_KIDNEY_DECLINED" /* LEFT_KIDNEY_DECLINED */ :
                        return t("session_update_left_kidney_declined");
                    case "RIGHT_KIDNEY_HANDED_OFF_TO_COURIER" /* RIGHT_KIDNEY_HANDED_OFF_TO_COURIER */ :
                        return t("session_update_right_kidney_handed_off_to_courier");
                    case "LEFT_KIDNEY_HANDED_OFF_TO_COURIER" /* LEFT_KIDNEY_HANDED_OFF_TO_COURIER */ :
                        return t("session_update_left_kidney_handed_off_to_courier");
                    case "RIGHT_KIDNEY_ARRIVED_AT_TXC_OR_OPO" /* RIGHT_KIDNEY_ARRIVED_AT_TXC_OR_OPO */ :
                        return t("session_update_right_kidney_arrived_at_txc_opo");
                    case "LEFT_KIDNEY_ARRIVED_AT_TXC_OR_OPO" /* LEFT_KIDNEY_ARRIVED_AT_TXC_OR_OPO */ :
                        return t("session_update_left_kidney_arrived_at_txc_opo");
                    case "RIGHT_KIDNEY_OUT_OF_STORAGE" /* RIGHT_KIDNEY_OUT_OF_STORAGE */ :
                        return t("session_update_right_kidney_out_of_device", {
                            transportDeviceName: transportDeviceName
                        });
                    case "LEFT_KIDNEY_OUT_OF_STORAGE" /* LEFT_KIDNEY_OUT_OF_STORAGE */ :
                        return t("session_update_left_kidney_out_of_device", {
                            transportDeviceName: transportDeviceName
                        });
                    case "RIGHT_KIDNEY_ARTERY_ANASTOMOSIS" /* RIGHT_KIDNEY_ARTERY_ANASTOMOSIS */ :
                        return t("session_update_right_kidney_artery_anastomosis");
                    case "RIGHT_KIDNEY_VEIN_ANASTOMOSIS" /* RIGHT_KIDNEY_VEIN_ANASTOMOSIS */ :
                        return t("session_update_right_kidney_vein_anastomosis");
                    case "RIGHT_KIDNEY_URETER_ANASTOMOSIS" /* RIGHT_KIDNEY_URETER_ANASTOMOSIS */ :
                        return t("session_update_right_kidney_ureter_anostomosis");
                    case "LEFT_KIDNEY_ARTERY_ANASTOMOSIS" /* LEFT_KIDNEY_ARTERY_ANASTOMOSIS */ :
                        return t("session_update_left_kidney_artery_anastomosis");
                    case "LEFT_KIDNEY_VEIN_ANASTOMOSIS" /* LEFT_KIDNEY_VEIN_ANASTOMOSIS */ :
                        return t("session_update_left_kidney_vein_anastomosis");
                    case "LEFT_KIDNEY_URETER_ANASTOMOSIS" /* LEFT_KIDNEY_URETER_ANASTOMOSIS */ :
                        return t("session_update_left_kidney_ureter_anostomosis");
                    case "HEAD_VESSEL_CLAMP" /* HEAD_VESSEL_CLAMP */ :
                        return t("session_update_head_vessel_clamp");
                    case "ON_CARDIO_PULMONARY_BYPASS_1" /* ON_CARDIO_PULMONARY_BYPASS_1 */ :
                        return t("session_update_on_cardio_pulmonary_bypass_1");
                    case "START_WEAN_1" /* START_WEAN_1 */ :
                        return t("session_update_start_wean_1");
                    case "OFF_CARDIO_PULMONARY_BYPASS_1" /* OFF_CARDIO_PULMONARY_BYPASS_1 */ :
                        return t("session_update_off_cardio_pulmonary_bypass_1");
                    case "ON_CARDIO_PULMONARY_BYPASS_2" /* ON_CARDIO_PULMONARY_BYPASS_2 */ :
                        return t("session_update_on_cardio_pulmonary_bypass_2");
                    case "START_WEAN_2" /* START_WEAN_2 */ :
                        return t("session_update_start_wean_2");
                    case "OFF_CARDIO_PULMONARY_BYPASS_2" /* OFF_CARDIO_PULMONARY_BYPASS_2 */ :
                        return t("session_update_off_cardio_pulmonary_bypass_2");
                    case "ANASTOMOSIS" /* ANASTOMOSIS */ :
                        return t("session_update_anastomosis");
                    case "COLD_PRESERVATION_FLUSH" /* COLD_PRESERVATION_FLUSH */ :
                        return t("session_update_cold_preservation_flush");
                    case "CANNULATION" /* CANNULATION */ :
                        return "".concat(t("session_update_cannulation")).concat(cannulationTypeAnnotation);
                    default:
                        return t("session_update_unknown");
                }
            }
        }
    ]);
    return TimelineEntryTypeUtil;
}();
// src/modelUtils/NotificationUtil.ts
var NotificationUtil = /*#__PURE__*/ function() {
    function NotificationUtil() {
        _classCallCheck(this, NotificationUtil);
    }
    _createClass(NotificationUtil, null, [
        {
            key: "payloadToNotification",
            value: function payloadToNotification(payload) {
                if (payload.data == null) {
                    throw new Error("No data in notification payload");
                }
                if (payload.data.type === "timeline") {
                    return this.fromTimelineType(payload);
                }
                if (payload.data.type === "session" && payload.data.eta != null) {
                    return this.fromETAType(payload);
                }
                if (payload.data.type === "session" && payload.data.eta == null) {
                    return this.fromForgotSessionType(payload);
                }
                if (payload.data.type === "members") {
                    return this.fromMembersType(payload);
                }
                throw new Error("Notification type not supported");
            }
        },
        {
            key: "fromTimelineType",
            value: function fromTimelineType(payload) {
                var t = import_translations5.default.t;
                var data = payload.data;
                return new Notification({
                    type: data.type,
                    title: ProductUtil.toHeading(data.product),
                    body: t("notification_type_timeline_update_text").replace("%s", TimelineEntryTypeUtil.toUIString(data.timelineEntryType, data.product)),
                    iconSrc: ProductUtil.iconPath(data.product, true),
                    action: {
                        text: t("to_session"),
                        to: "".concat(import_constants3.Routes.web.SESSION_DETAIL.replace(":id", data.sessionId), "?tabId=timeline")
                    },
                    isDismissable: true
                });
            }
        },
        {
            key: "fromETAType",
            value: function fromETAType(payload) {
                var t = import_translations5.default.t;
                var data = payload.data;
                return new Notification({
                    type: data.type,
                    title: ProductUtil.toHeading(data.product),
                    body: t("notification_type_eta_update_text").replace("%s", data.senderName),
                    iconSrc: ProductUtil.iconPath(data.product, true),
                    action: {
                        text: t("to_session"),
                        to: import_constants3.Routes.web.SESSION_DETAIL.replace(":id", data.sessionId)
                    },
                    isDismissable: true
                });
            }
        },
        {
            key: "fromForgotSessionType",
            value: function fromForgotSessionType(payload) {
                var t = import_translations5.default.t;
                var data = payload.data, notification = payload.notification;
                return new Notification({
                    type: data.type,
                    title: ProductUtil.toHeading(data.product),
                    body: "".concat(notification.title, " ").concat(notification.body),
                    iconSrc: ProductUtil.iconPath(data.product, true),
                    action: {
                        text: t("to_session"),
                        to: import_constants3.Routes.web.SESSION_DETAIL.replace(":id", data.sessionId)
                    },
                    isDismissable: true
                });
            }
        },
        {
            key: "fromMembersType",
            value: function fromMembersType(payload) {
                var t = import_translations5.default.t;
                var data = payload.data;
                return new Notification({
                    type: data.type,
                    title: ProductUtil.toHeading(data.product),
                    body: t("notification_type_new_member_text").replace("%s", data.senderName),
                    iconSrc: ProductUtil.iconPath(data.product, true),
                    action: {
                        text: t("to_session"),
                        to: "".concat(import_constants3.Routes.web.SESSION_DETAIL.replace(":id", data.sessionId), "?tabId=info")
                    },
                    isDismissable: true
                });
            }
        }
    ]);
    return NotificationUtil;
}();
// src/modelUtils/OrganizationMemberAccessRoleUtil.ts
var OrganizationMemberAccessRoleUtil = /*#__PURE__*/ function() {
    function OrganizationMemberAccessRoleUtil() {
        _classCallCheck(this, OrganizationMemberAccessRoleUtil);
    }
    _createClass(OrganizationMemberAccessRoleUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(status) {
                switch(status){
                    case "ADMIN" /* ADMIN */ :
                        return "Admin";
                    case "VIEWER" /* VIEWER */ :
                        return "Viewer";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return OrganizationMemberAccessRoleUtil;
}();
// src/modelUtils/OrganizationMemberDeactivationReasonUtil.ts
var OrganizationMemberDeactivationReasonUtil = /*#__PURE__*/ function() {
    function OrganizationMemberDeactivationReasonUtil() {
        _classCallCheck(this, OrganizationMemberDeactivationReasonUtil);
    }
    _createClass(OrganizationMemberDeactivationReasonUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(reason) {
                switch(reason){
                    case "LEFT_ORGANIZATION" /* LEFT_ORGANIZATION */ :
                        return "Left organization";
                    case "DEACTIVATED" /* DEACTIVATED */ :
                        return "Deactivated";
                    case "ACCESS_REQUEST_DECLINED" /* ACCESS_REQUEST_DECLINED */ :
                        return "Access request declined";
                    case "USER_DOES_NOT_EXIST" /* USER_DOES_NOT_EXIST */ :
                        return "User does not exist";
                    case null:
                        return "Unknown";
                    case void 0:
                        return "Unknown";
                    default:
                        return reason;
                }
            }
        }
    ]);
    return OrganizationMemberDeactivationReasonUtil;
}();
// src/modelUtils/OrganizationMemberStatusUtil.ts
var OrganizationMemberStatusUtil = /*#__PURE__*/ function() {
    function OrganizationMemberStatusUtil() {
        _classCallCheck(this, OrganizationMemberStatusUtil);
    }
    _createClass(OrganizationMemberStatusUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(status) {
                switch(status){
                    case "PRESELECTED" /* PRESELECTED */ :
                        return "Pre-selected";
                    case "ACCESS_REQUESTED" /* ACCESS_REQUESTED */ :
                        return "Access requested";
                    case "CREATED" /* CREATED */ :
                        return "Created";
                    case "INVITED" /* INVITED */ :
                        return "Invited";
                    case "ACTIVE" /* ACTIVE */ :
                        return "Active";
                    case "INACTIVE" /* INACTIVE */ :
                        return "Inactive";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return OrganizationMemberStatusUtil;
}();
// src/modelUtils/OrganizationStatusUtil.ts
var OrganizationStatusUtil = /*#__PURE__*/ function() {
    function OrganizationStatusUtil() {
        _classCallCheck(this, OrganizationStatusUtil);
    }
    _createClass(OrganizationStatusUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(status) {
                switch(status){
                    case "CREATE_REQUESTED" /* CREATE_REQUESTED */ :
                        return "Create requested";
                    case "CREATED" /* CREATED */ :
                        return "Created";
                    case "IN_VALIDATION" /* IN_VALIDATION */ :
                        return "In validation";
                    case "ACTIVE" /* ACTIVE */ :
                        return "Active";
                    case "INACTIVE" /* INACTIVE */ :
                        return "Inactive";
                    default:
                        return "Unknown";
                }
            }
        }
    ]);
    return OrganizationStatusUtil;
}();
// src/modelUtils/OrganTypeUtil.ts
var import_assets2 = require("@packages/assets");
var import_constants4 = require("@packages/constants");
var import_translations6 = __toESM(require("@packages/translations"));
var OrganTypeUtil = /*#__PURE__*/ function() {
    function OrganTypeUtil() {
        _classCallCheck(this, OrganTypeUtil);
    }
    _createClass(OrganTypeUtil, null, [
        {
            key: "organString",
            value: function organString(organ) {
                var t = import_translations6.default.t;
                if (organ === "lung" /* LUNG */ ) {
                    return t("organ_lung");
                }
                if (organ === "liver" /* LIVER */ ) {
                    return t("organ_liver");
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return t("organ_kidney");
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return t("organ_pancreas");
                }
                return t("organ_heart");
            }
        },
        {
            key: "iconPath",
            value: function iconPath(organ) {
                var background = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (organ === "lung" /* LUNG */ ) {
                    return background ? import_assets2.Assets.organs.lungIconBgPng : import_assets2.Assets.organs.lungIconPng;
                }
                if (organ === "liver" /* LIVER */ ) {
                    return background ? import_assets2.Assets.organs.liverIconBgPng : import_assets2.Assets.organs.liverIconPng;
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return background ? import_assets2.Assets.organs.kidneyIconBgPng : import_assets2.Assets.organs.kidneyIconPng;
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return background ? import_assets2.Assets.organs.pancreasIconBgPng : import_assets2.Assets.organs.pancreasIconPng;
                }
                return background ? import_assets2.Assets.organs.heartIconBgPng : import_assets2.Assets.organs.heartIconPng;
            }
        },
        {
            key: "markerSvg",
            value: function markerSvg(organ) {
                if (organ === "lung" /* LUNG */ ) {
                    return import_assets2.Assets.markers.lung;
                }
                if (organ === "liver" /* LIVER */ ) {
                    return import_assets2.Assets.markers.liver;
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return import_assets2.Assets.markers.kidney;
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return import_assets2.Assets.markers.pancreas;
                }
                return import_assets2.Assets.markers.heart;
            }
        },
        {
            key: "flightMarkerSvg",
            value: function flightMarkerSvg(organ) {
                var heading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
                return this.matchHeading(organ, heading);
            }
        },
        {
            key: "matchHeading",
            value: function matchHeading(organ) {
                var heading = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 90;
                var _obj;
                var MARKER_MAP = (_obj = {}, _defineProperty(_obj, "heart" /* HEART */ , [
                    import_assets2.Assets.markers.heartMarkerFlightSvg0,
                    import_assets2.Assets.markers.heartMarkerFlightSvg45,
                    import_assets2.Assets.markers.heartMarkerFlightSvg90,
                    import_assets2.Assets.markers.heartMarkerFlightSvg135,
                    import_assets2.Assets.markers.heartMarkerFlightSvg180,
                    import_assets2.Assets.markers.heartMarkerFlightSvg225,
                    import_assets2.Assets.markers.heartMarkerFlightSvg270,
                    import_assets2.Assets.markers.heartMarkerFlightSvg315,
                    import_assets2.Assets.markers.heartMarkerFlightSvg360
                ]), _defineProperty(_obj, "unknown" /* UNKNOWN */ , [
                    import_assets2.Assets.markers.heartMarkerFlightSvg0,
                    import_assets2.Assets.markers.heartMarkerFlightSvg45,
                    import_assets2.Assets.markers.heartMarkerFlightSvg90,
                    import_assets2.Assets.markers.heartMarkerFlightSvg135,
                    import_assets2.Assets.markers.heartMarkerFlightSvg180,
                    import_assets2.Assets.markers.heartMarkerFlightSvg225,
                    import_assets2.Assets.markers.heartMarkerFlightSvg270,
                    import_assets2.Assets.markers.heartMarkerFlightSvg315,
                    import_assets2.Assets.markers.heartMarkerFlightSvg360
                ]), _defineProperty(_obj, "lung" /* LUNG */ , [
                    import_assets2.Assets.markers.lungMarkerFlightSvg0,
                    import_assets2.Assets.markers.lungMarkerFlightSvg45,
                    import_assets2.Assets.markers.lungMarkerFlightSvg90,
                    import_assets2.Assets.markers.lungMarkerFlightSvg135,
                    import_assets2.Assets.markers.lungMarkerFlightSvg180,
                    import_assets2.Assets.markers.lungMarkerFlightSvg225,
                    import_assets2.Assets.markers.lungMarkerFlightSvg270,
                    import_assets2.Assets.markers.lungMarkerFlightSvg315,
                    import_assets2.Assets.markers.lungMarkerFlightSvg360
                ]), _defineProperty(_obj, "liver" /* LIVER */ , [
                    import_assets2.Assets.markers.liverMarkerFlightSvg0,
                    import_assets2.Assets.markers.liverMarkerFlightSvg45,
                    import_assets2.Assets.markers.liverMarkerFlightSvg90,
                    import_assets2.Assets.markers.liverMarkerFlightSvg135,
                    import_assets2.Assets.markers.liverMarkerFlightSvg180,
                    import_assets2.Assets.markers.liverMarkerFlightSvg225,
                    import_assets2.Assets.markers.liverMarkerFlightSvg270,
                    import_assets2.Assets.markers.liverMarkerFlightSvg315,
                    import_assets2.Assets.markers.liverMarkerFlightSvg360
                ]), _defineProperty(_obj, "kidney" /* KIDNEY */ , [
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg0,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg45,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg90,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg135,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg180,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg225,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg270,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg315,
                    import_assets2.Assets.markers.kidneyMarkerFlightSvg360
                ]), _defineProperty(_obj, "pancreas" /* PANCREAS */ , [
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg0,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg45,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg90,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg135,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg180,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg225,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg270,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg315,
                    import_assets2.Assets.markers.pancreasMarkerFlightSvg360
                ]), _obj);
                var INDEX_MAP = [
                    0,
                    45,
                    90,
                    135,
                    180,
                    225,
                    270,
                    315,
                    360
                ];
                var closest = INDEX_MAP.reduce(function(prev, curr) {
                    return Math.abs(curr - heading) < Math.abs(prev - heading) ? curr : prev;
                });
                var index = INDEX_MAP.findIndex(function(elem) {
                    return elem === closest;
                });
                return MARKER_MAP[organ !== null && organ !== void 0 ? organ : "heart" /* HEART */ ][index];
            }
        },
        {
            key: "tiveMarkerSvg",
            value: function tiveMarkerSvg(organ) {
                if (organ === "lung" /* LUNG */ ) {
                    return import_assets2.Assets.markers.lungMarkerTiveSvg;
                }
                if (organ === "liver" /* LIVER */ ) {
                    return import_assets2.Assets.markers.liverMarkerTiveSvg;
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return import_assets2.Assets.markers.kidneyMarkerTiveSvg;
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return import_assets2.Assets.markers.pancreasMarkerTiveSvg;
                }
                return import_assets2.Assets.markers.heartMarkerTiveSvg;
            }
        },
        {
            key: "colors",
            value: function colors(organ) {
                if (organ === "heart" /* HEART */ ) {
                    return {
                        primary: import_constants4.Colors.COLOR_HEART_PRIMARY,
                        primaryLight: import_constants4.Colors.COLOR_HEART_PRIMARY_LIGHT
                    };
                }
                if (organ === "lung" /* LUNG */ ) {
                    return {
                        primary: import_constants4.Colors.COLOR_LUNG_PRIMARY,
                        primaryLight: import_constants4.Colors.COLOR_LUNG_PRIMARY_LIGHT
                    };
                }
                if (organ === "liver" /* LIVER */ ) {
                    return {
                        primary: import_constants4.Colors.COLOR_LIVER_PRIMARY,
                        primaryLight: import_constants4.Colors.COLOR_LIVER_PRIMARY_LIGHT
                    };
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return {
                        primary: import_constants4.Colors.COLOR_PANCREAS_PRIMARY,
                        primaryLight: import_constants4.Colors.COLOR_PANCREAS_PRIMARY_LIGHT
                    };
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return {
                        primary: import_constants4.Colors.COLOR_KIDNEY_PRIMARY,
                        primaryLight: import_constants4.Colors.COLOR_KIDNEY_PRIMARY_LIGHT
                    };
                }
                return {
                    primary: import_constants4.Colors.COLOR_HEART_PRIMARY,
                    primaryLight: import_constants4.Colors.COLOR_HEART_PRIMARY_LIGHT
                };
            }
        },
        {
            key: "cssClass",
            value: function cssClass(organ) {
                if (organ === "lung" /* LUNG */ ) {
                    return "lungguard";
                }
                if (organ === "liver" /* LIVER */ ) {
                    return "liverguard";
                }
                if (organ === "kidney" /* KIDNEY */ ) {
                    return "kts";
                }
                if (organ === "pancreas" /* PANCREAS */ ) {
                    return "pancreaspak";
                }
                return "sherpapak";
            }
        }
    ]);
    return OrganTypeUtil;
}();
// src/modelUtils/SessionTypeUtil.ts
var import_constants5 = require("@packages/constants");
var import_translations7 = __toESM(require("@packages/translations"));
var SessionTypeUtil = /*#__PURE__*/ function() {
    function SessionTypeUtil() {
        _classCallCheck(this, SessionTypeUtil);
    }
    _createClass(SessionTypeUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(type) {
                var t = import_translations7.default.t;
                switch(type){
                    case "CLINICAL" /* CLINICAL */ :
                        return t("session_type_clinical");
                    case "TRAINING" /* TRAINING */ :
                        return t("session_type_training");
                    default:
                        return t("session_type_unknown");
                }
            }
        },
        {
            key: "colors",
            value: function colors(type) {
                switch(type){
                    case "TRAINING" /* TRAINING */ :
                        return import_constants5.Colors.COLOR_SESSION_TYPE_PRIMARY;
                    case "CLINICAL" /* CLINICAL */ :
                        return import_constants5.Colors.COLOR_SESSION_TYPE_PRIMARY_LIGHT;
                    default:
                        return import_constants5.Colors.COLOR_UNKNOWN_PRIMARY_LIGHT;
                }
            }
        }
    ]);
    return SessionTypeUtil;
}();
// src/modelUtils/UserDeactivationReasonUtil.ts
var UserDeactivationReasonUtil = /*#__PURE__*/ function() {
    function UserDeactivationReasonUtil() {
        _classCallCheck(this, UserDeactivationReasonUtil);
    }
    _createClass(UserDeactivationReasonUtil, null, [
        {
            key: "toUIString",
            value: function toUIString(reason) {
                switch(reason){
                    case "LEFT_ORGANIZATION" /* LEFT_ORGANIZATION */ :
                        return "Left organization";
                    case null:
                        return "Unknown";
                    case void 0:
                        return "Unknown";
                    default:
                        return reason;
                }
            }
        }
    ]);
    return UserDeactivationReasonUtil;
}();
// src/models/TimelineEntryType.ts
var TimelineEntryType = /* @__PURE__ */ function(TimelineEntryType2) {
    TimelineEntryType2["START_SESSION"] = "START_SESSION";
    TimelineEntryType2["LEAVE_TX_CENTER"] = "LEAVE_TX_CENTER";
    TimelineEntryType2["PLANE_DEPARTURE_RECIPIENT"] = "PLANE_DEPARTURE_RECIPIENT";
    TimelineEntryType2["PLANE_ARRIVAL_DONOR"] = "PLANE_ARRIVAL_DONOR";
    TimelineEntryType2["ARRIVAL_AT_DONOR"] = "ARRIVAL_AT_DONOR";
    TimelineEntryType2["DONOR_IN_ROOM"] = "DONOR_IN_ROOM";
    TimelineEntryType2["TIME_TO_INCISION"] = "TIME_TO_INCISION";
    TimelineEntryType2["HEPARIN_ADMINISTERED"] = "HEPARIN_ADMINISTERED";
    TimelineEntryType2["CROSSCLAMP_AT_DONOR"] = "CROSSCLAMP_AT_DONOR";
    TimelineEntryType2["ORGAN_REMOVAL"] = "ORGAN_REMOVAL";
    TimelineEntryType2["START_LOGGER"] = "START_LOGGER";
    TimelineEntryType2["LEAVE_DONOR"] = "LEAVE_DONOR";
    TimelineEntryType2["PLANE_DEPARTURE_DONOR"] = "PLANE_DEPARTURE_DONOR";
    TimelineEntryType2["PLANE_ARRIVAL_RECIPIENT"] = "PLANE_ARRIVAL_RECIPIENT";
    TimelineEntryType2["ARRIVE_AT_RECIPIENT"] = "ARRIVE_AT_RECIPIENT";
    TimelineEntryType2["STOP_LOGGER"] = "STOP_LOGGER";
    TimelineEntryType2["CROSSCLAMP_AT_RECIPIENT"] = "CROSSCLAMP_AT_RECIPIENT";
    TimelineEntryType2["STOP_SESSION"] = "STOP_SESSION";
    TimelineEntryType2["ORGAN_ACCEPTED"] = "ORGAN_ACCEPTED";
    TimelineEntryType2["ORGAN_DECLINED"] = "ORGAN_DECLINED";
    TimelineEntryType2["TIME_OF_WITHDRAWAL"] = "TIME_OF_WITHDRAWAL";
    TimelineEntryType2["WARM_ISCHEMIC_TIME_START"] = "WARM_ISCHEMIC_TIME_START";
    TimelineEntryType2["OBSERVATION_PERIOD_START"] = "OBSERVATION_PERIOD_START";
    TimelineEntryType2["TIME_OF_DEATH"] = "TIME_OF_DEATH";
    TimelineEntryType2["ORGAN_REMOVAL_LUNG"] = "ORGAN_REMOVAL_LUNG";
    TimelineEntryType2["HEART_REMOVED_FROM_SHERPAPAK"] = "HEART_REMOVED_FROM_SHERPAPAK";
    TimelineEntryType2["HEART_PLACED_IN_SHERPAPAK"] = "HEART_PLACED_IN_SHERPAPAK";
    TimelineEntryType2["LUNGS_REMOVED_FROM_LUNGGUARD"] = "LUNGS_REMOVED_FROM_LUNGGUARD";
    TimelineEntryType2["LUNG_PLACED_IN_LUNGGUARD"] = "LUNG_PLACED_IN_LUNGGUARD";
    TimelineEntryType2["LIVER_REMOVED_FROM_LIVERGUARD"] = "LIVER_REMOVED_FROM_LIVERGUARD";
    TimelineEntryType2["LIVER_PLACED_IN_LIVERGUARD"] = "LIVER_PLACED_IN_LIVERGUARD";
    TimelineEntryType2["LEFT_LUNG_REMOVED_FROM_LUNGGUARD"] = "LEFT_LUNG_REMOVED_FROM_LUNGGUARD";
    TimelineEntryType2["RIGHT_LUNG_REMOVED_FROM_LUNGGUARD"] = "RIGHT_LUNG_REMOVED_FROM_LUNGGUARD";
    TimelineEntryType2["LEFT_LUNG_ANASTOMOSIS_COMPLETE"] = "LEFT_LUNG_ANASTOMOSIS_COMPLETE";
    TimelineEntryType2["RIGHT_LUNG_ANASTOMOSIS_COMPLETE"] = "RIGHT_LUNG_ANASTOMOSIS_COMPLETE";
    TimelineEntryType2["ORGAN_REMOVAL_LIVER"] = "ORGAN_REMOVAL_LIVER";
    TimelineEntryType2["ORGAN_REMOVAL_PANCREAS"] = "ORGAN_REMOVAL_PANCREAS";
    TimelineEntryType2["PANCREAS_PLACED_IN_PANCREASPAK"] = "PANCREAS_PLACED_IN_PANCREASPAK";
    TimelineEntryType2["PANCREAS_REMOVED_FROM_PANCREASPAK"] = "PANCREAS_REMOVED_FROM_PANCREASPAK";
    TimelineEntryType2["PORTAL_REPERFUSION"] = "PORTAL_REPERFUSION";
    TimelineEntryType2["ARTERIAL_REPERFUSION"] = "ARTERIAL_REPERFUSION";
    TimelineEntryType2["PERFUSION_START"] = "PERFUSION_START";
    TimelineEntryType2["PERFUSION_STOP"] = "PERFUSION_STOP";
    TimelineEntryType2["RECIPIENT_LEFT_LUNG_OFF_CLAMP"] = "RECIPIENT_LEFT_LUNG_OFF_CLAMP";
    TimelineEntryType2["RECIPIENT_RIGHT_LUNG_OFF_CLAMP"] = "RECIPIENT_RIGHT_LUNG_OFF_CLAMP";
    TimelineEntryType2["KIDNEY_DONOR_FINAL_BLOOD_UREA_NITROGEN"] = "KIDNEY_DONOR_FINAL_BLOOD_UREA_NITROGEN";
    TimelineEntryType2["KIDNEY_DONOR_FINAL_SERUM_CREATININE"] = "KIDNEY_DONOR_FINAL_SERUM_CREATININE";
    TimelineEntryType2["KIDNEY_DONOR_KIDNEY_DONOR_PROFILE_INDEX"] = "KIDNEY_DONOR_KIDNEY_DONOR_PROFILE_INDEX";
    TimelineEntryType2["KIDNEY_WITHDRAWAL_OF_SUPPORT"] = "KIDNEY_WITHDRAWAL_OF_SUPPORT";
    TimelineEntryType2["KIDNEY_START_AGONAL_PHASE"] = "KIDNEY_START_AGONAL_PHASE";
    TimelineEntryType2["KIDNEY_START_FLUSH"] = "KIDNEY_START_FLUSH";
    TimelineEntryType2["KIDNEY_X_CLAMP"] = "KIDNEY_X_CLAMP";
    TimelineEntryType2["RIGHT_KIDNEY_REMOVAL"] = "RIGHT_KIDNEY_REMOVAL";
    TimelineEntryType2["LEFT_KIDNEY_REMOVAL"] = "LEFT_KIDNEY_REMOVAL";
    TimelineEntryType2["RIGHT_KIDNEY_PLACED_INTO_STORAGE"] = "RIGHT_KIDNEY_PLACED_INTO_STORAGE";
    TimelineEntryType2["LEFT_KIDNEY_PLACED_INTO_STORAGE"] = "LEFT_KIDNEY_PLACED_INTO_STORAGE";
    TimelineEntryType2["RIGHT_KIDNEY_ACCEPTED"] = "RIGHT_KIDNEY_ACCEPTED";
    TimelineEntryType2["RIGHT_KIDNEY_DECLINED"] = "RIGHT_KIDNEY_DECLINED";
    TimelineEntryType2["LEFT_KIDNEY_ACCEPTED"] = "LEFT_KIDNEY_ACCEPTED";
    TimelineEntryType2["LEFT_KIDNEY_DECLINED"] = "LEFT_KIDNEY_DECLINED";
    TimelineEntryType2["RIGHT_KIDNEY_HANDED_OFF_TO_COURIER"] = "RIGHT_KIDNEY_HANDED_OFF_TO_COURIER";
    TimelineEntryType2["LEFT_KIDNEY_HANDED_OFF_TO_COURIER"] = "LEFT_KIDNEY_HANDED_OFF_TO_COURIER";
    TimelineEntryType2["RIGHT_KIDNEY_ARRIVED_AT_TXC_OR_OPO"] = "RIGHT_KIDNEY_ARRIVED_AT_TXC_OR_OPO";
    TimelineEntryType2["LEFT_KIDNEY_ARRIVED_AT_TXC_OR_OPO"] = "LEFT_KIDNEY_ARRIVED_AT_TXC_OR_OPO";
    TimelineEntryType2["RIGHT_KIDNEY_OUT_OF_STORAGE"] = "RIGHT_KIDNEY_OUT_OF_STORAGE";
    TimelineEntryType2["LEFT_KIDNEY_OUT_OF_STORAGE"] = "LEFT_KIDNEY_OUT_OF_STORAGE";
    TimelineEntryType2["RIGHT_KIDNEY_ARTERY_ANASTOMOSIS"] = "RIGHT_KIDNEY_ARTERY_ANASTOMOSIS";
    TimelineEntryType2["RIGHT_KIDNEY_VEIN_ANASTOMOSIS"] = "RIGHT_KIDNEY_VEIN_ANASTOMOSIS";
    TimelineEntryType2["RIGHT_KIDNEY_URETER_ANASTOMOSIS"] = "RIGHT_KIDNEY_URETER_ANASTOMOSIS";
    TimelineEntryType2["LEFT_KIDNEY_ARTERY_ANASTOMOSIS"] = "LEFT_KIDNEY_ARTERY_ANASTOMOSIS";
    TimelineEntryType2["LEFT_KIDNEY_VEIN_ANASTOMOSIS"] = "LEFT_KIDNEY_VEIN_ANASTOMOSIS";
    TimelineEntryType2["LEFT_KIDNEY_URETER_ANASTOMOSIS"] = "LEFT_KIDNEY_URETER_ANASTOMOSIS";
    TimelineEntryType2["HEAD_VESSEL_CLAMP"] = "HEAD_VESSEL_CLAMP";
    TimelineEntryType2["ON_CARDIO_PULMONARY_BYPASS_1"] = "ON_CARDIO_PULMONARY_BYPASS_1";
    TimelineEntryType2["START_WEAN_1"] = "START_WEAN_1";
    TimelineEntryType2["OFF_CARDIO_PULMONARY_BYPASS_1"] = "OFF_CARDIO_PULMONARY_BYPASS_1";
    TimelineEntryType2["ON_CARDIO_PULMONARY_BYPASS_2"] = "ON_CARDIO_PULMONARY_BYPASS_2";
    TimelineEntryType2["START_WEAN_2"] = "START_WEAN_2";
    TimelineEntryType2["OFF_CARDIO_PULMONARY_BYPASS_2"] = "OFF_CARDIO_PULMONARY_BYPASS_2";
    TimelineEntryType2["ANASTOMOSIS"] = "ANASTOMOSIS";
    TimelineEntryType2["COLD_PRESERVATION_FLUSH"] = "COLD_PRESERVATION_FLUSH";
    TimelineEntryType2["CANNULATION"] = "CANNULATION";
    return TimelineEntryType2;
}(TimelineEntryType || {});
// src/models/TimelineEntry.ts
var TimelineEntry = /*#__PURE__*/ function() {
    function TimelineEntry(param) {
        var type = param.type, timestamp = param.timestamp, annotations = param.annotations;
        _classCallCheck(this, TimelineEntry);
        this.t = import_translations8.default.t;
        this.type = type;
        this.timestamp = timestamp;
        this.annotations = annotations;
    }
    _createClass(TimelineEntry, [
        {
            key: "getTitle",
            value: function getTitle(product) {
                return TimelineEntryTypeUtil.toUIString(this.type, product, this.annotations);
            }
        },
        {
            key: "exportEvent",
            value: function exportEvent() {
                return this.t("timeline_entry");
            }
        },
        {
            key: "exportValue",
            value: function exportValue(product) {
                return this.getTitle(product);
            }
        },
        {
            key: "exportDescription",
            value: function exportDescription(session) {
                if (this.type === "START_SESSION" /* START_SESSION */ ) {
                    var _session_joinKey;
                    var resultElems = [
                        (_session_joinKey = session === null || session === void 0 ? void 0 : session.joinKey) !== null && _session_joinKey !== void 0 ? _session_joinKey : "no session key",
                        ProductUtil.toHeading(session === null || session === void 0 ? void 0 : session.product),
                        (session === null || session === void 0 ? void 0 : session.donationType) != null ? DonationTypeUtil.toUIString(session === null || session === void 0 ? void 0 : session.donationType) : "no donation type",
                        (session === null || session === void 0 ? void 0 : session.sessionType) != null ? SessionTypeUtil.toUIString(session === null || session === void 0 ? void 0 : session.sessionType) : "no session type",
                        (session === null || session === void 0 ? void 0 : session.unosId) != null ? "Donor ID:".concat(session.unosId) : "no Donor ID added"
                    ];
                    return resultElems.join(" / ");
                }
                if (this.type === "START_LOGGER" /* START_LOGGER */ ) {
                    var _session_loggerSerialNo;
                    return (_session_loggerSerialNo = session === null || session === void 0 ? void 0 : session.loggerSerialNo) !== null && _session_loggerSerialNo !== void 0 ? _session_loggerSerialNo : "-";
                }
                return "";
            }
        }
    ]);
    return TimelineEntry;
}();
// src/models/Tutorial.ts
var Tutorial = function Tutorial(param) {
    var id = param.id, title = param.title, sort = param.sort, videoRefName = param.videoRefName, text = param.text, imageRefName = param.imageRefName;
    _classCallCheck(this, Tutorial);
    this.id = id;
    this.title = title;
    this.sort = sort;
    this.videoRefName = videoRefName;
    this.text = text;
    this.imageRefName = imageRefName;
};
// src/models/User.ts
var User = /*#__PURE__*/ function() {
    function User(param) {
        var id = param.id, email = param.email, _param_emailVerified = param.emailVerified, emailVerified = _param_emailVerified === void 0 ? false : _param_emailVerified, firstname = param.firstname, lastname = param.lastname, organization = param.organization, role = param.role, permissions = param.permissions, acceptedTermsVersion = param.acceptedTermsVersion, settings = param.settings, timezone = param.timezone, timezoneName = param.timezoneName, _param_organizationIds = param.organizationIds, organizationIds = _param_organizationIds === void 0 ? [] : _param_organizationIds, _param_activeInOrganizationIds = param.activeInOrganizationIds, activeInOrganizationIds = _param_activeInOrganizationIds === void 0 ? [] : _param_activeInOrganizationIds, _param_needsEmailVerification = param.needsEmailVerification, needsEmailVerification = _param_needsEmailVerification === void 0 ? false : _param_needsEmailVerification, _param_needsOrganizationProfile = param.needsOrganizationProfile, needsOrganizationProfile = _param_needsOrganizationProfile === void 0 ? false : _param_needsOrganizationProfile, _param_recentDestinations = param.recentDestinations, recentDestinations = _param_recentDestinations === void 0 ? [] : _param_recentDestinations, deactivatedAt = param.deactivatedAt, deactivationReason = param.deactivationReason;
        _classCallCheck(this, User);
        this.id = id;
        this.email = email;
        this.emailVerified = emailVerified;
        this.firstname = firstname;
        this.lastname = lastname;
        this.organization = organization;
        this.role = role;
        this.permissions = permissions;
        this.acceptedTermsVersion = acceptedTermsVersion;
        this.settings = settings;
        this.timezone = timezone;
        this.timezoneName = timezoneName;
        this.organizationIds = organizationIds;
        this.activeInOrganizationIds = activeInOrganizationIds;
        this.needsOrganizationProfile = needsOrganizationProfile;
        this.needsEmailVerification = needsEmailVerification;
        this.recentDestinations = recentDestinations;
        this.deactivatedAt = deactivatedAt;
        this.deactivationReason = deactivationReason;
    }
    _createClass(User, [
        {
            key: "fullname",
            get: function get() {
                return "".concat(this.firstname, " ").concat(this.lastname);
            }
        }
    ]);
    return User;
}();
// src/models/UserDeactivationReason.ts
var UserDeactivationReason = /* @__PURE__ */ function(UserDeactivationReason2) {
    UserDeactivationReason2["LEFT_ORGANIZATION"] = "LEFT_ORGANIZATION";
    return UserDeactivationReason2;
}(UserDeactivationReason || {});
// src/models/UserSettings.ts
var UserSettings = function UserSettings(param) {
    var includeTimezone = param.includeTimezone, force24HoursFormat = param.force24HoursFormat, allowMarketingMails = param.allowMarketingMails, allowSessionReportMails = param.allowSessionReportMails, forceDistanceUnit = param.forceDistanceUnit;
    _classCallCheck(this, UserSettings);
    this.includeTimezone = includeTimezone !== null && includeTimezone !== void 0 ? includeTimezone : false;
    this.force24HoursFormat = force24HoursFormat !== null && force24HoursFormat !== void 0 ? force24HoursFormat : true;
    this.allowMarketingMails = allowMarketingMails;
    this.allowSessionReportMails = allowSessionReportMails !== null && allowSessionReportMails !== void 0 ? allowSessionReportMails : true;
    this.forceDistanceUnit = forceDistanceUnit;
};
// src/converters/destination.converter.ts
var destinationConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new Destination(data);
    }
};
// src/converters/document.converter.ts
var documentConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new Document(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id
        }));
    }
};
// src/converters/location.converter.ts
var locationConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_timestamp;
        var data = doc.data();
        return new LoggerLocation(_objectSpreadProps(_objectSpread({}, data), {
            timestamp: (_data_timestamp = data.timestamp) === null || _data_timestamp === void 0 ? void 0 : _data_timestamp.toDate()
        }));
    }
};
// src/converters/log.converter.ts
var logConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var log = doc.data().log;
        var readings = log.map(function(elem) {
            return new ReadingCompressed({
                t: elem.t,
                e: elem.e,
                a: elem.a,
                p: elem.p,
                pr: elem.pr,
                pv: elem.pv
            }).toReading();
        });
        return new Log({
            log: readings
        });
    }
};
// src/converters/organization.converter.ts
var organizationConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_createdAt, _data_updatedAt, _data_validationStartedAt, _data_activatedAt;
        var data = doc.data();
        return new Organization(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id,
            createdAt: (_data_createdAt = data.createdAt) === null || _data_createdAt === void 0 ? void 0 : _data_createdAt.toDate(),
            updatedAt: (_data_updatedAt = data.updatedAt) === null || _data_updatedAt === void 0 ? void 0 : _data_updatedAt.toDate(),
            validationStartedAt: (_data_validationStartedAt = data.validationStartedAt) === null || _data_validationStartedAt === void 0 ? void 0 : _data_validationStartedAt.toDate(),
            activatedAt: (_data_activatedAt = data.activatedAt) === null || _data_activatedAt === void 0 ? void 0 : _data_activatedAt.toDate()
        }));
    }
};
// src/converters/organizationMember.converter.ts
var organizationMemberConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_startOfEmployment, _data_createdAt, _data_updatedAt, _data_accessRequestedAt, _data_invitedAt, _data_lastInvitedAt, _data_activatedAt, _data_deactivatedAt;
        var data = doc.data();
        return new OrganizationMember(_objectSpreadProps(_objectSpread({
            id: doc.id
        }, data), {
            startOfEmployment: (_data_startOfEmployment = data.startOfEmployment) === null || _data_startOfEmployment === void 0 ? void 0 : _data_startOfEmployment.toDate(),
            createdAt: (_data_createdAt = data.createdAt) === null || _data_createdAt === void 0 ? void 0 : _data_createdAt.toDate(),
            updatedAt: (_data_updatedAt = data.updatedAt) === null || _data_updatedAt === void 0 ? void 0 : _data_updatedAt.toDate(),
            accessRequestedAt: (_data_accessRequestedAt = data.accessRequestedAt) === null || _data_accessRequestedAt === void 0 ? void 0 : _data_accessRequestedAt.toDate(),
            invitedAt: (_data_invitedAt = data.invitedAt) === null || _data_invitedAt === void 0 ? void 0 : _data_invitedAt.toDate(),
            lastInvitedAt: (_data_lastInvitedAt = data.lastInvitedAt) === null || _data_lastInvitedAt === void 0 ? void 0 : _data_lastInvitedAt.toDate(),
            activatedAt: (_data_activatedAt = data.activatedAt) === null || _data_activatedAt === void 0 ? void 0 : _data_activatedAt.toDate(),
            deactivatedAt: (_data_deactivatedAt = data.deactivatedAt) === null || _data_deactivatedAt === void 0 ? void 0 : _data_deactivatedAt.toDate()
        }));
    }
};
// src/converters/organizationMemberRole.converter.ts
var organizationMemberRoleConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new OrganizationMemberRole(_objectSpread({
            id: doc.id
        }, data));
    }
};
// src/converters/organizationOption.converter.ts
var organizationOptionConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new OrganizationOption(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id
        }));
    }
};
// src/converters/organizationPreselectedMember.converter.ts
var organizationPreselectedMemberConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_createdAt, _data_updatedAt, _data_confirmedAt;
        var data = doc.data();
        return new OrganizationPreselectedMember(_objectSpreadProps(_objectSpread({
            id: doc.id
        }, data), {
            createdAt: (_data_createdAt = data.createdAt) === null || _data_createdAt === void 0 ? void 0 : _data_createdAt.toDate(),
            updatedAt: (_data_updatedAt = data.updatedAt) === null || _data_updatedAt === void 0 ? void 0 : _data_updatedAt.toDate(),
            confirmedAt: (_data_confirmedAt = data.confirmedAt) === null || _data_confirmedAt === void 0 ? void 0 : _data_confirmedAt.toDate()
        }));
    }
};
// src/converters/organizationType.converter.ts
var organizationTypeConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new OrganizationType(_objectSpread({
            id: doc.id
        }, data));
    }
};
// src/converters/organizationUnregisteredInvite.converter.ts
var organizationUnregisteredInviteConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_createdAt, _data_updatedAt;
        var data = doc.data();
        return new OrganizationUnregisteredInvite(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id,
            createdAt: (_data_createdAt = data.createdAt) === null || _data_createdAt === void 0 ? void 0 : _data_createdAt.toDate(),
            updatedAt: (_data_updatedAt = data.updatedAt) === null || _data_updatedAt === void 0 ? void 0 : _data_updatedAt.toDate()
        }));
    }
};
// src/converters/product.converter.ts
var productConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new Product(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id,
            product: ProductUtil.fromId(doc.id)
        }));
    }
};
// src/models/LoggerData.ts
var LoggerData = function LoggerData(param) {
    var probe2 = param.probe, ambient = param.ambient, pressure3 = param.pressure, timestamp = param.timestamp;
    _classCallCheck(this, LoggerData);
    this.probe = probe2;
    this.ambient = ambient;
    this.pressure = pressure3;
    this.timestamp = timestamp;
};
// src/converters/session.converter.ts
var sessionConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_createdAt, _data_endedAt, _data_eta;
        var data = doc.data();
        return new Session(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id,
            createdAt: (_data_createdAt = data.createdAt) === null || _data_createdAt === void 0 ? void 0 : _data_createdAt.toDate(),
            endedAt: (_data_endedAt = data.endedAt) === null || _data_endedAt === void 0 ? void 0 : _data_endedAt.toDate(),
            eta: (_data_eta = data.eta) === null || _data_eta === void 0 ? void 0 : _data_eta.toDate(),
            reportData: createSessionReportData(data.reportData),
            metrics: createMetrics(data.metrics),
            metadata: createSessionMetadata(data.metadata),
            ischemicTime: createSessionIschemicTime(data.ischemicTime),
            loggerData: createLoggerData(data.loggerData, data.temperature),
            product: ProductUtil.fromId(data.product),
            flights: createFlights(data.flights),
            flightPosition: createFlightPosition(data.flightPosition),
            advancedTracking: createAdvancedTracking(data.advancedTracking),
            organ: data.organ != null && data.organ.length > 0 ? data.organ : ProductUtil.organTypeFromProduct(data.product)
        }));
    }
};
function createSessionReportData(reportData) {
    var _reportData_loggerStartedAt, _reportData_loggerStoppedAt, _reportData_firstReading, _reportData_lastReading;
    return reportData != null ? new SessionReportData({
        ambientAverage: reportData.ambientAverage,
        ambientMaximum: reportData.ambientMaximum,
        ambientMinimum: reportData.ambientMinimum,
        probeAverage: reportData.probeAverage,
        probeMaximum: reportData.probeMaximum,
        probeMinimum: reportData.probeMinimum,
        pressureAverage: reportData.pressureAverage,
        pressureMaximum: reportData.pressureMaximum,
        pressureMinimum: reportData.pressureMinimum,
        pumpVoltageStart: reportData.pumpVoltageStart,
        pumpVoltageEnd: reportData.pumpVoltageEnd,
        distance: reportData.distance,
        readingsCount: reportData.readingsCount,
        loggerStartedAt: (_reportData_loggerStartedAt = reportData.loggerStartedAt) === null || _reportData_loggerStartedAt === void 0 ? void 0 : _reportData_loggerStartedAt.toDate(),
        loggerStoppedAt: (_reportData_loggerStoppedAt = reportData.loggerStoppedAt) === null || _reportData_loggerStoppedAt === void 0 ? void 0 : _reportData_loggerStoppedAt.toDate(),
        loggingDurationMillis: reportData.loggingDurationMillis,
        firstReading: (_reportData_firstReading = reportData.firstReading) === null || _reportData_firstReading === void 0 ? void 0 : _reportData_firstReading.toDate(),
        lastReading: (_reportData_lastReading = reportData.lastReading) === null || _reportData_lastReading === void 0 ? void 0 : _reportData_lastReading.toDate()
    }) : void 0;
}
function createMetrics(metrics) {
    return metrics != null ? new SessionMetrics({
        memberCount: metrics.memberCount,
        timelineCount: metrics.timelineCount,
        messageCount: metrics.messageCount
    }) : void 0;
}
function createSessionIschemicTime(ischemicTime4) {
    var _ischemicTime4_startTimestamp, _ischemicTime4_endTimestamp;
    return ischemicTime4 != null ? new SessionIschemicTime({
        startType: TimelineEntryType[ischemicTime4.startType],
        endType: TimelineEntryType[ischemicTime4.endType],
        startedAt: (_ischemicTime4_startTimestamp = ischemicTime4.startTimestamp) === null || _ischemicTime4_startTimestamp === void 0 ? void 0 : _ischemicTime4_startTimestamp.toDate(),
        endedAt: (_ischemicTime4_endTimestamp = ischemicTime4.endTimestamp) === null || _ischemicTime4_endTimestamp === void 0 ? void 0 : _ischemicTime4_endTimestamp.toDate()
    }) : void 0;
}
function createLoggerData(loggerData, temperature3) {
    if (loggerData) {
        var _loggerData_timestamp;
        return new LoggerData({
            probe: loggerData.probe,
            ambient: loggerData.ambient,
            pressure: loggerData.pressure,
            timestamp: (_loggerData_timestamp = loggerData.timestamp) === null || _loggerData_timestamp === void 0 ? void 0 : _loggerData_timestamp.toDate()
        });
    }
    if (temperature3) {
        var _temperature3_timestamp;
        return new LoggerData({
            probe: temperature3.probe,
            ambient: temperature3.ambient,
            pressure: void 0,
            timestamp: (_temperature3_timestamp = temperature3.timestamp) === null || _temperature3_timestamp === void 0 ? void 0 : _temperature3_timestamp.toDate()
        });
    }
    return void 0;
}
function createFlights(flights) {
    return flights != null && flights.length > 0 ? flights.map(function(flight) {
        var _flight_dataTimestamp, _flight_actualArrival, _flight_actualDeparture, _flight_estimatedDeparture, _flight_estimatedArrival, _flight_plannedArrival, _flight_plannedDeparture;
        return new Flight(_objectSpreadProps(_objectSpread({}, flight), {
            state: FlightState[flight.state],
            dataTimestamp: (_flight_dataTimestamp = flight.dataTimestamp) === null || _flight_dataTimestamp === void 0 ? void 0 : _flight_dataTimestamp.toDate(),
            actualArrival: (_flight_actualArrival = flight.actualArrival) === null || _flight_actualArrival === void 0 ? void 0 : _flight_actualArrival.toDate(),
            actualDeparture: (_flight_actualDeparture = flight.actualDeparture) === null || _flight_actualDeparture === void 0 ? void 0 : _flight_actualDeparture.toDate(),
            estimatedDeparture: (_flight_estimatedDeparture = flight.estimatedDeparture) === null || _flight_estimatedDeparture === void 0 ? void 0 : _flight_estimatedDeparture.toDate(),
            estimatedArrival: (_flight_estimatedArrival = flight.estimatedArrival) === null || _flight_estimatedArrival === void 0 ? void 0 : _flight_estimatedArrival.toDate(),
            plannedArrival: (_flight_plannedArrival = flight.plannedArrival) === null || _flight_plannedArrival === void 0 ? void 0 : _flight_plannedArrival.toDate(),
            plannedDeparture: (_flight_plannedDeparture = flight.plannedDeparture) === null || _flight_plannedDeparture === void 0 ? void 0 : _flight_plannedDeparture.toDate()
        }));
    }) : void 0;
}
function createFlightPosition(flightPosition) {
    var _flightPosition_timestamp;
    return flightPosition != null ? new FlightPosition(_objectSpreadProps(_objectSpread({}, flightPosition), {
        timestamp: (_flightPosition_timestamp = flightPosition.timestamp) === null || _flightPosition_timestamp === void 0 ? void 0 : _flightPosition_timestamp.toDate()
    })) : void 0;
}
function createAdvancedTracking(advancedTracking) {
    var _advancedTracking_timestamp;
    return advancedTracking != null ? new AdvancedTracking(_objectSpreadProps(_objectSpread({}, advancedTracking), {
        timestamp: (_advancedTracking_timestamp = advancedTracking.timestamp) === null || _advancedTracking_timestamp === void 0 ? void 0 : _advancedTracking_timestamp.toDate()
    })) : void 0;
}
function createSessionMetadata(metadata) {
    var _metadata_stopReminderSent, _metadata_forceStopAfter48Hours;
    return metadata != null ? new SessionMetadata({
        stopReminderSent: (_metadata_stopReminderSent = metadata.stopReminderSent) !== null && _metadata_stopReminderSent !== void 0 ? _metadata_stopReminderSent : false,
        forceStopAfter48Hours: (_metadata_forceStopAfter48Hours = metadata.forceStopAfter48Hours) !== null && _metadata_forceStopAfter48Hours !== void 0 ? _metadata_forceStopAfter48Hours : false
    }) : void 0;
}
// src/converters/sessionMember.converter.ts
var sessionMemberConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_joinedAt;
        var data = doc.data();
        return new SessionMember(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id,
            joinedAt: (_data_joinedAt = data.joinedAt) === null || _data_joinedAt === void 0 ? void 0 : _data_joinedAt.toDate()
        }));
    }
};
// src/converters/timeline.converter.ts
var timelineConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_timestamp;
        var data = doc.data();
        return new TimelineEntry(_objectSpreadProps(_objectSpread({}, data), {
            timestamp: (_data_timestamp = data.timestamp) === null || _data_timestamp === void 0 ? void 0 : _data_timestamp.toDate()
        }));
    }
};
// src/converters/tive.converter.ts
var tiveLocationConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_timestamp;
        var data = doc.data();
        return new LoggerLocation(_objectSpreadProps(_objectSpread({}, data), {
            timestamp: (_data_timestamp = data.timestamp) === null || _data_timestamp === void 0 ? void 0 : _data_timestamp.toDate(),
            horizontalAccuracy: -1,
            verticalAccuracy: -1
        }));
    }
};
// src/converters/tutorial.converter.ts
var tutorialConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var data = doc.data();
        return new Tutorial(_objectSpreadProps(_objectSpread({}, data), {
            id: doc.id
        }));
    }
};
// src/converters/user.converter.ts
var userConverter = {
    toFirestore: function toFirestore() {
        return {};
    },
    fromFirestore: function fromFirestore(doc) {
        var _data_settings, _data_settings1, _data_settings2, _data_settings3, _data_settings4, _data_deactivatedAt;
        var data = doc.data();
        var userSettings = new UserSettings({
            includeTimezone: (_data_settings = data.settings) === null || _data_settings === void 0 ? void 0 : _data_settings.includeTimezone,
            force24HoursFormat: (_data_settings1 = data.settings) === null || _data_settings1 === void 0 ? void 0 : _data_settings1.force24hours,
            allowMarketingMails: (_data_settings2 = data.settings) === null || _data_settings2 === void 0 ? void 0 : _data_settings2.marketingMails,
            allowSessionReportMails: (_data_settings3 = data.settings) === null || _data_settings3 === void 0 ? void 0 : _data_settings3.sessionReportMails,
            forceDistanceUnit: (_data_settings4 = data.settings) === null || _data_settings4 === void 0 ? void 0 : _data_settings4.forceDistanceUnit
        });
        return new User(_objectSpreadProps(_objectSpread({}, doc.data()), {
            id: doc.id,
            deactivatedAt: (_data_deactivatedAt = data.deactivatedAt) === null || _data_deactivatedAt === void 0 ? void 0 : _data_deactivatedAt.toDate(),
            settings: userSettings
        }));
    }
};
// src/utils/generateEmailReportData/index.ts
var import_constants7 = require("@packages/constants");
// src/utils/generateEmailReportData/generateBarChartImageUrl.ts
var import_constants6 = require("@packages/constants");
var QuickChart = require("quickchart-js");
function generateBarChartImageUrl(session, value, comparisonValue, formatter, config) {
    var myChart = new QuickChart(config.apiKey, config.accountId);
    if (value === 0 && comparisonValue === 0) {
        return import_constants6.ImageUrls.BAR_CHART_DISCLAIMER_NOTICE;
    }
    myChart.setConfig({
        type: "horizontalBar",
        data: {
            labels: [
                "Case"
            ],
            datasets: [
                {
                    label: "This case",
                    data: [
                        value
                    ],
                    borderColor: ProductUtil.colors(session.product).primaryLight,
                    backgroundColor: ProductUtil.colors(session.product).primaryLight,
                    fill: false,
                    pointRadius: 0,
                    pointStyle: "circle",
                    datalabels: {
                        color: ProductUtil.colors(session.product).primary
                    },
                    categoryPercentage: 1,
                    barPercentage: 0.7
                },
                {
                    label: "All cases",
                    data: [
                        comparisonValue
                    ],
                    borderColor: "#E7E7E9",
                    backgroundColor: "#E7E7E9",
                    fill: false,
                    pointRadius: 0,
                    pointStyle: "circle",
                    datalabels: {
                        color: import_constants6.Colors.COLOR_AMBIENT
                    },
                    categoryPercentage: 1,
                    barPercentage: 0.7
                }
            ]
        },
        options: {
            plugins: {
                roundedBars: true,
                datalabels: {
                    display: true,
                    anchor: "end",
                    align: "left",
                    backgroundColor: "transparent",
                    font: {
                        size: 50
                    },
                    padding: {
                        right: 40
                    },
                    formatter: formatter
                }
            },
            legend: {
                position: "bottom",
                align: "center",
                labels: {
                    usePointStyle: true,
                    fontSize: 50,
                    padding: 50
                }
            },
            scales: {
                xAxes: [
                    {
                        display: false,
                        gridLines: {
                            display: false
                        },
                        ticks: {
                            min: 0
                        }
                    }
                ],
                yAxes: [
                    {
                        display: false,
                        gridLines: {
                            display: false
                        }
                    }
                ]
            }
        }
    }).setWidth(800).setHeight(400).setBackgroundColor("transparent");
    return myChart.getUrl();
}
// src/utils/generateEmailReportData/generateMetrics.ts
var THRESHOLDS = {
    probe: 1,
    ischemicTime: 1,
    distance: 1
};
function generateMetrics(session, sessions) {
    return {
        probe: probe(session),
        ischemicTime: ischemicTime(session),
        distance: distance(session),
        all: {
            probe: probeAll(sessions),
            ischemicTime: ischemicTimeAll(sessions),
            distance: distanceAll(sessions)
        }
    };
}
function probe(session) {
    var _session_reportData;
    var avg = (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeAverage;
    return avg != null && avg >= THRESHOLDS.probe ? avg : 0;
}
function probeAll(sessions) {
    var averages = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            var _session_reportData;
            if (((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeAverage) != null) {
                var _session_reportData1;
                averages.push((_session_reportData1 = session.reportData) === null || _session_reportData1 === void 0 ? void 0 : _session_reportData1.probeAverage);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var avg = averages.reduce(function(sum, current) {
        return sum + current;
    }, 0) / averages.length;
    return avg != null && avg >= THRESHOLDS.probe ? avg : 0;
}
function ischemicTime(session) {
    if (session.ischemicTime == null) {
        return 0;
    }
    var value = session.ischemicTime.endedAt.getTime() - session.ischemicTime.startedAt.getTime();
    return value >= THRESHOLDS.ischemicTime ? value : 0;
}
function ischemicTimeAll(sessions) {
    var durations = sessions.filter(function(session) {
        return session.ischemicTime != null;
    }).map(function(session) {
        var _session_ischemicTime, _session_ischemicTime1;
        return ((_session_ischemicTime = session.ischemicTime) === null || _session_ischemicTime === void 0 ? void 0 : _session_ischemicTime.endedAt.getTime()) - ((_session_ischemicTime1 = session.ischemicTime) === null || _session_ischemicTime1 === void 0 ? void 0 : _session_ischemicTime1.startedAt.getTime());
    }).filter(function(elem) {
        return elem != null;
    });
    var avg = durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length;
    return avg >= THRESHOLDS.ischemicTime ? avg : 0;
}
function distance(session) {
    var _session_reportData;
    var value = (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance;
    return value != null && value >= THRESHOLDS.distance ? value : 0;
}
function distanceAll(sessions) {
    var distances = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance;
    });
    var avg = distances.reduce(function(sum, current) {
        return sum + current;
    }, 0) / distances.length;
    return avg != null && avg >= THRESHOLDS.distance ? avg : 0;
}
// src/utils/generateEmailReportData/generatePressureChartImageUrl.ts
var import_utils4 = require("@packages/utils");
// src/utils/findClosestReadingTime.ts
function findClosestReadingTime(readings, value, startMilliseconds) {
    return readings.sort(function(a, b) {
        return Math.abs(a.timestamp.getTime() - startMilliseconds - value) - Math.abs(b.timestamp.getTime() - startMilliseconds - value);
    })[0];
}
// src/utils/generateEmailReportData/generatePressureChartImageUrl.ts
var QuickChart2 = require("quickchart-js");
function generatePressureChartImageUrl(session, readings, config) {
    return _generatePressureChartImageUrl.apply(this, arguments);
}
function _generatePressureChartImageUrl() {
    _generatePressureChartImageUrl = _asyncToGenerator(function(session, readings, config) {
        var myChart, startedEvent, _readings_find, latestEvent, validReadings, startedMilliseconds, latestMilliseconds, ticks, tickedReadings, data;
        return __generator(this, function(_state) {
            myChart = new QuickChart2(config.apiKey, config.accountId).setVersion("3.7.0");
            startedEvent = readings.find(function(reading) {
                return reading.isStartedEvent();
            });
            latestEvent = (_readings_find = readings.find(function(reading) {
                return reading.isStoppedEvent();
            })) !== null && _readings_find !== void 0 ? _readings_find : readings[readings.length - 1];
            if (startedEvent == null || latestEvent == null) {
                throw new Error("Session does not have a started or latest event");
            }
            validReadings = getValidReadings(readings);
            startedMilliseconds = startedEvent.timestamp.getTime();
            latestMilliseconds = latestEvent.timestamp.getTime();
            ticks = (0, import_utils4.calculateChartTicks)(startedMilliseconds, latestMilliseconds);
            tickedReadings = ticks.map(function(tick) {
                return findClosestReadingTime(validReadings, tick, startedMilliseconds);
            });
            data = validReadings.map(function(reading) {
                return {
                    pressure: reading.pressure
                };
            }).reverse();
            myChart.setConfig({
                type: "line",
                data: {
                    labels: validReadings.map(function(reading) {
                        var tickedReadingIndex = tickedReadings.findIndex(function(elem) {
                            return elem.timestamp.getTime() === reading.timestamp.getTime();
                        });
                        return tickedReadingIndex !== tickedReadings.length - 1 && ticks[tickedReadingIndex] != null ? (0, import_utils4.millisecondsToTime)(ticks[tickedReadingIndex], {
                            seconds: false
                        }) : "";
                    }).reverse(),
                    datasets: [
                        {
                            label: "Pressure",
                            data: data.map(function(elem) {
                                return elem.pressure;
                            }),
                            borderColor: ProductUtil.colors(session.product).primary,
                            backgroundColor: ProductUtil.colors(session.product).primary,
                            fill: false,
                            pointRadius: 0,
                            pointStyle: "circle"
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            position: "bottom",
                            align: "center",
                            labels: {
                                usePointStyle: true,
                                padding: 20
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: true,
                                drawBorder: true,
                                drawOnChartArea: false,
                                drawTicks: false
                            },
                            ticks: {
                                autoSkip: false,
                                autoRotate: false,
                                maxRotation: 0,
                                minRotation: 0
                            }
                        },
                        y: {
                            suggestedMin: 0,
                            suggestedMax: 27,
                            stepSize: 2,
                            beginAtZero: true,
                            grid: {
                                display: true,
                                drawBorder: true,
                                drawOnChartArea: true,
                                drawTicks: false
                            },
                            ticks: {
                                callback: function(value) {
                                    return "".concat(Math.round(Number(value) * 10) / 10);
                                }
                            }
                        }
                    }
                }
            }).setWidth(800).setHeight(400).setBackgroundColor("transparent");
            return [
                2,
                myChart.getShortUrl()
            ];
        });
    });
    return _generatePressureChartImageUrl.apply(this, arguments);
}
function getValidReadings(readings) {
    var validReadings = readings.filter(function(reading) {
        return reading.isReading();
    });
    var reductionFactor = Math.ceil(validReadings.length / 250);
    return validReadings.filter(function(_, index) {
        return index % reductionFactor === 0;
    });
}
// src/utils/generateEmailReportData/generateSessionDetails.ts
var import_utils5 = require("@packages/utils");
function generateSessionDetails(session, destination) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _session_reportData;
    return {
        key: session.joinKey,
        unosId: session.unosId,
        destination: (destination === null || destination === void 0 ? void 0 : destination.name) && (destination === null || destination === void 0 ? void 0 : destination.handle) ? "".concat(destination.name, " (").concat(destination.handle, ")") : void 0,
        productType: "Paragonix ".concat(ProductUtil.toHeading(session.product), " [").concat(DonationTypeUtil.toUIString(session.donationType), "]"),
        sessionType: SessionTypeUtil.toUIString(session.sessionType),
        started: (session === null || session === void 0 ? void 0 : session.createdAt) != null ? (0, import_utils5.formatDate)(session.createdAt, {
            timezoneOffset: options.timezoneOffset,
            timezoneName: options.timezoneName
        }) : "-",
        stopped: (session === null || session === void 0 ? void 0 : session.endedAt) != null ? (0, import_utils5.formatDate)(session.endedAt, {
            timezoneOffset: options.timezoneOffset,
            timezoneName: options.timezoneName
        }) : "-",
        duration: (session === null || session === void 0 ? void 0 : (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis) != null ? (0, import_utils5.millisecondsToTime)(session.reportData.loggingDurationMillis, {
            seconds: false
        }) : "Unknown (Logger not stopped)"
    };
}
// src/utils/generateEmailReportData/generateTemperatureChartImageUrl.ts
var import_utils6 = require("@packages/utils");
var QuickChart3 = require("quickchart-js");
function generateTemperatureChartImageUrl(session, readings, config) {
    return _generateTemperatureChartImageUrl.apply(this, arguments);
}
function _generateTemperatureChartImageUrl() {
    _generateTemperatureChartImageUrl = _asyncToGenerator(function(session, readings, config) {
        var myChart, startedEvent, _readings_find, latestEvent, validReadings, startedMilliseconds, latestMilliseconds, ticks, tickedReadings, data;
        return __generator(this, function(_state) {
            myChart = new QuickChart3(config.apiKey, config.accountId).setVersion("3.7.0");
            startedEvent = readings.find(function(reading) {
                return reading.isStartedEvent();
            });
            latestEvent = (_readings_find = readings.find(function(reading) {
                return reading.isStoppedEvent();
            })) !== null && _readings_find !== void 0 ? _readings_find : readings[readings.length - 1];
            if (startedEvent == null || latestEvent == null) {
                throw new Error("Session does not have a started or latest event");
            }
            validReadings = getValidReadings2(readings);
            startedMilliseconds = startedEvent.timestamp.getTime();
            latestMilliseconds = latestEvent.timestamp.getTime();
            ticks = (0, import_utils6.calculateChartTicks)(startedMilliseconds, latestMilliseconds);
            tickedReadings = ticks.map(function(tick) {
                return findClosestReadingTime(validReadings, tick, startedMilliseconds);
            });
            data = validReadings.map(function(reading) {
                return {
                    probe: reading.probe
                };
            }).reverse();
            myChart.setConfig({
                type: "line",
                data: {
                    labels: validReadings.map(function(reading) {
                        var tickedReadingIndex = tickedReadings.findIndex(function(elem) {
                            return elem.timestamp.getTime() === reading.timestamp.getTime();
                        });
                        return tickedReadingIndex !== tickedReadings.length - 1 && ticks[tickedReadingIndex] != null ? (0, import_utils6.millisecondsToTime)(ticks[tickedReadingIndex], {
                            seconds: false
                        }) : "";
                    }).reverse(),
                    datasets: [
                        {
                            label: "Probe",
                            data: data.map(function(elem) {
                                return elem.probe;
                            }),
                            borderColor: ProductUtil.colors(session.product).primary,
                            backgroundColor: ProductUtil.colors(session.product).primary,
                            fill: false,
                            pointRadius: 0,
                            pointStyle: "circle"
                        }
                    ]
                },
                options: {
                    plugins: {
                        legend: {
                            position: "bottom",
                            align: "center",
                            labels: {
                                usePointStyle: true,
                                padding: 20
                            }
                        }
                    },
                    scales: {
                        x: {
                            grid: {
                                display: true,
                                drawBorder: true,
                                drawOnChartArea: false,
                                drawTicks: false
                            },
                            ticks: {
                                autoSkip: false,
                                autoRotate: false,
                                maxRotation: 0,
                                minRotation: 0
                            }
                        },
                        y: {
                            suggestedMin: 0,
                            suggestedMax: 12,
                            stepSize: 2,
                            beginAtZero: true,
                            grid: {
                                display: true,
                                drawBorder: true,
                                drawOnChartArea: true,
                                drawTicks: false
                            },
                            ticks: {
                                callback: function(value) {
                                    return "".concat(Math.round(Number(value) * 10) / 10, "\xb0C");
                                }
                            }
                        }
                    }
                }
            }).setWidth(800).setHeight(400).setBackgroundColor("transparent");
            return [
                2,
                myChart.getShortUrl()
            ];
        });
    });
    return _generateTemperatureChartImageUrl.apply(this, arguments);
}
function getValidReadings2(readings) {
    var validReadings = readings.filter(function(reading) {
        return reading.isReading();
    });
    var reductionFactor = Math.ceil(validReadings.length / 250);
    return validReadings.filter(function(_, index) {
        return index % reductionFactor === 0;
    });
}
function generateEmailReportData(session, sessions, readings, destination, config) {
    return _generateEmailReportData.apply(this, arguments);
}
function _generateEmailReportData() {
    _generateEmailReportData = // src/utils/generateEmailReportData/index.ts
    _asyncToGenerator(function(session, sessions, readings, destination, config) {
        var metrics, probeFormatter, ischemicTimeFormatter, distanceFormatterMetric, distanceFormatterImperial, probeChartUrl, ischemicChartUrl, distanceChartUrl, showDisclaimer, disclaimerImages, showDisclaimerAPTD, showDisclaimerIT, showDisclaimerCD, subject, _tmp, _tmp1, _tmp2;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    metrics = generateMetrics(session, sessions);
                    probeFormatter = function(value) {
                        return "".concat((Math.round(Number(value) * 10) / 10).toFixed(1), "\xb0C");
                    };
                    ischemicTimeFormatter = function(value) {
                        return "".concat(Math.floor(Number(value) / 1e3 / 60), "m");
                    };
                    distanceFormatterMetric = function(value) {
                        return "".concat(Math.floor(Number(value)), " km");
                    };
                    distanceFormatterImperial = function(value) {
                        return "".concat(Number((Math.round(Number(value) / 1.609344 * 100) / 100).toFixed(2)), " mi");
                    };
                    probeChartUrl = import_constants7.ImageUrls.BAR_CHART_DISCLAIMER_NOTICE;
                    ischemicChartUrl = import_constants7.ImageUrls.BAR_CHART_DISCLAIMER_NOTICE;
                    distanceChartUrl = import_constants7.ImageUrls.BAR_CHART_DISCLAIMER_NOTICE;
                    showDisclaimer = false;
                    if (metrics.probe > 0) {
                        probeChartUrl = generateBarChartImageUrl(session, metrics.probe, metrics.all.probe, probeFormatter, config.quickcharts);
                    } else {
                        showDisclaimer = true;
                    }
                    if (metrics.distance > 0) {
                        distanceChartUrl = generateBarChartImageUrl(session, metrics.distance, metrics.all.distance, config.distanceUnit === "imperial" /* IMPERIAL */  ? distanceFormatterImperial : distanceFormatterMetric, config.quickcharts);
                    } else {
                        showDisclaimer = true;
                    }
                    if (metrics.ischemicTime > 0) {
                        ischemicChartUrl = generateBarChartImageUrl(session, metrics.ischemicTime, metrics.all.ischemicTime, ischemicTimeFormatter, config.quickcharts);
                    } else {
                        showDisclaimer = true;
                    }
                    disclaimerImages = ProductUtil.disclaimerImages(session.product);
                    showDisclaimerAPTD = disclaimerImages.probeAverage != null;
                    showDisclaimerIT = disclaimerImages.ischemicTime != null;
                    showDisclaimerCD = disclaimerImages.connectDevice != null;
                    subject = session.unosId ? "Paragonix Case Report: ".concat(session.unosId, " (").concat(session.joinKey, ")") : "Paragonix Case Report: No Donor ID (".concat(session.joinKey, ")");
                    _tmp = {
                        subject: subject,
                        downloadUrl: "".concat(config.hostingUrl, "/download-session-report/").concat(session.id),
                        sessionUrl: "".concat(config.hostingUrl, "/sessions/").concat(session.id),
                        unsubscribeUrl: "".concat(config.hostingUrl, "/dashboard?modal=settings"),
                        product: ProductUtil.toHeading(session.product),
                        image: ProductUtil.imageUrl(session.product),
                        styles: _objectSpread({}, ProductUtil.colors(session.product)),
                        icons: ProductUtil.sessionDetailsIcons(session.product),
                        disclaimerImages: disclaimerImages,
                        showDisclaimer: showDisclaimer && (showDisclaimerAPTD || showDisclaimerIT || showDisclaimerCD),
                        showDisclaimerAPTD: showDisclaimerAPTD,
                        showDisclaimerIT: showDisclaimerIT,
                        showDisclaimerCD: showDisclaimerCD,
                        details: generateSessionDetails(session, destination, {
                            timezoneOffset: config.timezoneOffset,
                            timezoneName: config.timezoneName
                        }),
                        metrics: metrics
                    };
                    _tmp1 = {};
                    return [
                        4,
                        generateTemperatureChartImageUrl(session, readings, config.quickcharts)
                    ];
                case 1:
                    _tmp1.temperatureTimeline = _state.sent();
                    if (!(session.product === "baroguard" /* BAROGUARD */ )) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        generatePressureChartImageUrl(session, readings, config.quickcharts)
                    ];
                case 2:
                    _tmp2 = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    _tmp2 = null;
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        (_tmp.charts = (_tmp1.pressureTimeline = _tmp2, _tmp1.probe = probeChartUrl, _tmp1.ischemicTime = ischemicChartUrl, _tmp1.distance = distanceChartUrl, _tmp1), _tmp)
                    ];
            }
        });
    });
    return _generateEmailReportData.apply(this, arguments);
}
// src/utils/calculateSessionStats.ts
function calculateSessionStats(sessions) {
    var _obj;
    var filteredBy = (_obj = {}, _defineProperty(_obj, "sherpapak-cts" /* SHERPAPAK */ , sessions.filter(function(session) {
        return session.product == null || session.product === "sherpapak-cts" /* SHERPAPAK */ ;
    })), _defineProperty(_obj, "lungguard" /* LUNGGUARD */ , sessions.filter(function(session) {
        return session.product === "lungguard" /* LUNGGUARD */ ;
    })), _defineProperty(_obj, "baroguard" /* BAROGUARD */ , sessions.filter(function(session) {
        return session.product === "baroguard" /* BAROGUARD */ ;
    })), _defineProperty(_obj, "liverguard" /* LIVERGUARD */ , sessions.filter(function(session) {
        return session.product === "liverguard" /* LIVERGUARD */ ;
    })), _defineProperty(_obj, "pancreaspak" /* PANCREASPAK */ , sessions.filter(function(session) {
        return session.product === "pancreaspak" /* PANCREASPAK */ ;
    })), _defineProperty(_obj, "sherpapak-kts" /* KTS */ , sessions.filter(function(session) {
        return session.product === "sherpapak-kts" /* KTS */ ;
    })), _defineProperty(_obj, "vantage-point" /* VANTAGEPOINT */ , sessions.filter(function(session) {
        return session.product === "vantage-point" /* VANTAGEPOINT */ ;
    })), _defineProperty(_obj, "unknown" /* UNKNOWN */ , sessions.filter(function(session) {
        return session.product == null || session.product === "unknown" /* UNKNOWN */ ;
    })), _defineProperty(_obj, "heart" /* HEART */ , sessions.filter(function(session) {
        return session.product == null || session.product === "sherpapak-cts" /* SHERPAPAK */  || session.organ === "heart" /* HEART */ ;
    })), _defineProperty(_obj, "lung" /* LUNG */ , sessions.filter(function(session) {
        return session.product === "lungguard" /* LUNGGUARD */  || session.organ === "lung" /* LUNG */ ;
    })), _defineProperty(_obj, "liver" /* LIVER */ , sessions.filter(function(session) {
        return session.product === "liverguard" /* LIVERGUARD */  || session.organ === "liver" /* LIVER */ ;
    })), _defineProperty(_obj, "pancreas" /* PANCREAS */ , sessions.filter(function(session) {
        return session.product === "pancreaspak" /* PANCREASPAK */  || session.organ === "pancreas" /* PANCREAS */ ;
    })), _defineProperty(_obj, "kidney" /* KIDNEY */ , sessions.filter(function(session) {
        return session.product === "sherpapak-kts" /* KTS */  || session.organ === "kidney" /* KIDNEY */ ;
    })), _defineProperty(_obj, "DBD" /* DBD */ , sessions.filter(function(session) {
        return session.donationType === "DBD" /* DBD */ ;
    })), _defineProperty(_obj, "DCD" /* DCD */ , sessions.filter(function(session) {
        return session.donationType === "DCD" /* DCD */ ;
    })), _defineProperty(_obj, "UNKNOWN" /* UNKNOWN */ , sessions.filter(function(session) {
        return session.donationType == null || session.donationType === "UNKNOWN" /* UNKNOWN */ ;
    })), _defineProperty(_obj, "CLINICAL" /* CLINICAL */ , sessions.filter(function(session) {
        return session.sessionType === "CLINICAL" /* CLINICAL */ ;
    })), _defineProperty(_obj, "TRAINING" /* TRAINING */ , sessions.filter(function(session) {
        return session.sessionType === "TRAINING" /* TRAINING */ ;
    })), _obj);
    var _session_reportData_distance, _session_durationInMilliseconds, _session_reportData_loggingDurationMillis, _session_metrics_timelineCount;
    var _obj1, _obj2, _obj3, _obj4, _obj5;
    return {
        counts: {
            total: sessions.length,
            totalDistance: sessions.reduce(function(prev, session) {
                var _session_reportData;
                return prev + ((_session_reportData_distance = (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance) !== null && _session_reportData_distance !== void 0 ? _session_reportData_distance : 0);
            }, 0),
            totalDuration: sessions.reduce(function(prev, session) {
                return prev + ((_session_durationInMilliseconds = session.durationInMilliseconds()) !== null && _session_durationInMilliseconds !== void 0 ? _session_durationInMilliseconds : 0);
            }, 0),
            totalLoggingDuration: sessions.reduce(function(prev, session) {
                var _session_reportData;
                return prev + ((_session_reportData_loggingDurationMillis = (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis) !== null && _session_reportData_loggingDurationMillis !== void 0 ? _session_reportData_loggingDurationMillis : 0);
            }, 0),
            totalTimestamps: sessions.reduce(function(prev, session) {
                var _session_metrics;
                return prev + ((_session_metrics_timelineCount = (_session_metrics = session.metrics) === null || _session_metrics === void 0 ? void 0 : _session_metrics.timelineCount) !== null && _session_metrics_timelineCount !== void 0 ? _session_metrics_timelineCount : 0);
            }, 0),
            loggerConnected: {
                connected: sessions.filter(function(session) {
                    return session.loggerSerialNo != null;
                }).length,
                notConnected: sessions.filter(function(session) {
                    return session.loggerSerialNo == null;
                }).length
            },
            sessionMembersCount: {
                one: sessions.filter(function(session) {
                    var _session_userIds;
                    return ((_session_userIds = session.userIds) === null || _session_userIds === void 0 ? void 0 : _session_userIds.length) === 1;
                }).length,
                twoToFour: sessions.filter(function(session) {
                    var _session_userIds, _session_userIds1;
                    return ((_session_userIds = session.userIds) === null || _session_userIds === void 0 ? void 0 : _session_userIds.length) > 1 && ((_session_userIds1 = session.userIds) === null || _session_userIds1 === void 0 ? void 0 : _session_userIds1.length) < 5;
                }).length,
                fiveOrMore: sessions.filter(function(session) {
                    var _session_userIds;
                    return ((_session_userIds = session.userIds) === null || _session_userIds === void 0 ? void 0 : _session_userIds.length) > 4;
                }).length
            },
            flightCounts: {
                zero: sessions.filter(function(session) {
                    return session.flights == null || session.flights.length === 0;
                }).length,
                one: sessions.filter(function(session) {
                    return session.flights != null && session.flights.length === 1;
                }).length,
                twoOrMore: sessions.filter(function(session) {
                    return session.flights != null && session.flights.length > 1;
                }).length
            },
            destinationCounts: {
                set: sessions.filter(function(session) {
                    return session.destination != null;
                }).length,
                unknown: sessions.filter(function(session) {
                    return session.destination == null;
                }).length
            },
            unosIdCounts: {
                set: sessions.filter(function(session) {
                    return session.unosId != null;
                }).length,
                unknown: sessions.filter(function(session) {
                    return session.unosId == null;
                }).length
            },
            etaCounts: {
                set: sessions.filter(function(session) {
                    return session.eta != null;
                }).length,
                unknown: sessions.filter(function(session) {
                    return session.eta == null;
                }).length
            },
            destinations: sessions.reduce(function(prev, session) {
                var _prev_session_destination;
                if (session.destination == null) {
                    return prev;
                }
                var _prev_session_destination_total;
                return _objectSpreadProps(_objectSpread({}, prev), _defineProperty({}, session.destination, {
                    total: ((_prev_session_destination_total = (_prev_session_destination = prev[session.destination]) === null || _prev_session_destination === void 0 ? void 0 : _prev_session_destination.total) !== null && _prev_session_destination_total !== void 0 ? _prev_session_destination_total : 0) + 1
                }));
            }, {}),
            productType: (_obj1 = {}, _defineProperty(_obj1, "sherpapak-cts" /* SHERPAPAK */ , filteredBy["sherpapak-cts" /* SHERPAPAK */ ].length), _defineProperty(_obj1, "lungguard" /* LUNGGUARD */ , filteredBy["lungguard" /* LUNGGUARD */ ].length), _defineProperty(_obj1, "baroguard" /* BAROGUARD */ , filteredBy["baroguard" /* BAROGUARD */ ].length), _defineProperty(_obj1, "liverguard" /* LIVERGUARD */ , filteredBy["liverguard" /* LIVERGUARD */ ].length), _defineProperty(_obj1, "pancreaspak" /* PANCREASPAK */ , filteredBy["pancreaspak" /* PANCREASPAK */ ].length), _defineProperty(_obj1, "sherpapak-kts" /* KTS */ , filteredBy["sherpapak-kts" /* KTS */ ].length), _defineProperty(_obj1, "vantage-point" /* VANTAGEPOINT */ , filteredBy["vantage-point" /* VANTAGEPOINT */ ].length), _defineProperty(_obj1, "unknown" /* UNKNOWN */ , filteredBy["unknown" /* UNKNOWN */ ].length), _obj1),
            organType: (_obj2 = {}, _defineProperty(_obj2, "heart" /* HEART */ , filteredBy["heart" /* HEART */ ].length), _defineProperty(_obj2, "lung" /* LUNG */ , filteredBy["lung" /* LUNG */ ].length), _defineProperty(_obj2, "liver" /* LIVER */ , filteredBy["liver" /* LIVER */ ].length), _defineProperty(_obj2, "kidney" /* KIDNEY */ , filteredBy["kidney" /* KIDNEY */ ].length), _defineProperty(_obj2, "pancreas" /* PANCREAS */ , filteredBy["pancreas" /* PANCREAS */ ].length), _defineProperty(_obj2, "unknown" /* UNKNOWN */ , filteredBy["unknown" /* UNKNOWN */ ].length), _obj2),
            donationType: (_obj3 = {}, _defineProperty(_obj3, "DBD" /* DBD */ , filteredBy["DBD" /* DBD */ ].length), _defineProperty(_obj3, "DCD" /* DCD */ , filteredBy["DCD" /* DCD */ ].length), _defineProperty(_obj3, "UNKNOWN" /* UNKNOWN */ , filteredBy["UNKNOWN" /* UNKNOWN */ ].length), _obj3),
            sessionType: (_obj4 = {}, _defineProperty(_obj4, "CLINICAL" /* CLINICAL */ , filteredBy["CLINICAL" /* CLINICAL */ ].length), _defineProperty(_obj4, "TRAINING" /* TRAINING */ , filteredBy["TRAINING" /* TRAINING */ ].length), _defineProperty(_obj4, "UNKNOWN" /* UNKNOWN */ , filteredBy["UNKNOWN" /* UNKNOWN */ ].length), _obj4)
        },
        averages: (_obj5 = {
            all: calculateAverages(sessions)
        }, _defineProperty(_obj5, "sherpapak-cts" /* SHERPAPAK */ , calculateAverages(filteredBy["sherpapak-cts" /* SHERPAPAK */ ])), _defineProperty(_obj5, "lungguard" /* LUNGGUARD */ , calculateAverages(filteredBy["lungguard" /* LUNGGUARD */ ])), _defineProperty(_obj5, "baroguard" /* BAROGUARD */ , calculateAverages(filteredBy["baroguard" /* BAROGUARD */ ])), _defineProperty(_obj5, "liverguard" /* LIVERGUARD */ , calculateAverages(filteredBy["liverguard" /* LIVERGUARD */ ])), _defineProperty(_obj5, "pancreaspak" /* PANCREASPAK */ , calculateAverages(filteredBy["pancreaspak" /* PANCREASPAK */ ])), _defineProperty(_obj5, "sherpapak-kts" /* KTS */ , calculateAverages(filteredBy["sherpapak-kts" /* KTS */ ])), _defineProperty(_obj5, "vantage-point" /* VANTAGEPOINT */ , calculateAverages(filteredBy["vantage-point" /* VANTAGEPOINT */ ])), _defineProperty(_obj5, "unknown" /* UNKNOWN */ , calculateAverages(filteredBy["unknown" /* UNKNOWN */ ])), _obj5)
    };
}
function calculateAverages(sessions) {
    return {
        temperature: temperature(sessions),
        pressure: pressure(sessions),
        distance: distance2(sessions),
        duration: duration(sessions),
        loggingDuration: loggingDuration(sessions),
        ischemicTime: ischemicTime2(sessions)
    };
}
function temperature(sessions) {
    var minimums = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMinimum) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMinimum;
    });
    var maximums = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMaximum) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMaximum;
    });
    var averages = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeAverage) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeAverage;
    });
    return {
        min: minimums.length > 0 ? minimums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / minimums.length : void 0,
        max: maximums.length > 0 ? maximums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / maximums.length : void 0,
        avg: averages.length > 0 ? averages.reduce(function(sum, current) {
            return sum + current;
        }, 0) / averages.length : void 0
    };
}
function pressure(sessions) {
    var minimums = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureMinimum) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureMinimum;
    });
    var maximums = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureMaximum) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureMaximum;
    });
    var averages = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureAverage) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureAverage;
    });
    return {
        min: minimums.length > 0 ? minimums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / minimums.length : void 0,
        max: maximums.length > 0 ? maximums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / maximums.length : void 0,
        avg: averages.length > 0 ? averages.reduce(function(sum, current) {
            return sum + current;
        }, 0) / averages.length : void 0
    };
}
function distance2(sessions) {
    var _Math, _Math1;
    var distances = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance;
    });
    if (distances.length === 0) {
        return {
            min: void 0,
            max: void 0,
            avg: void 0
        };
    }
    return {
        min: (_Math = Math).min.apply(_Math, _toConsumableArray(distances)),
        max: (_Math1 = Math).max.apply(_Math1, _toConsumableArray(distances)),
        avg: distances.reduce(function(sum, current) {
            return sum + current;
        }, 0) / distances.length
    };
}
function duration(sessions) {
    var _Math, _Math1;
    var durations = sessions.map(function(session) {
        return session.durationInMilliseconds();
    }).filter(function(elem) {
        return elem != null;
    });
    if (durations.length === 0) {
        return {
            min: void 0,
            max: void 0,
            avg: void 0
        };
    }
    var min = (_Math = Math).min.apply(_Math, _toConsumableArray(durations));
    var max = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations));
    var avg = durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length;
    return {
        min: min > 0 ? min : void 0,
        max: max > 0 ? max : void 0,
        avg: avg > 0 ? avg : void 0
    };
}
function loggingDuration(sessions) {
    var _Math, _Math1;
    var durations = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis;
    });
    if (durations.length === 0) {
        return {
            min: void 0,
            max: void 0,
            avg: void 0
        };
    }
    var min = (_Math = Math).min.apply(_Math, _toConsumableArray(durations));
    var max = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations));
    var avg = durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length;
    return {
        min: min > 0 ? min : void 0,
        max: max > 0 ? max : void 0,
        avg: avg > 0 ? avg : void 0
    };
}
function ischemicTime2(sessions) {
    var _Math, _Math1;
    var durations = sessions.map(function(session) {
        var _session_ischemicTime;
        return (_session_ischemicTime = session.ischemicTime) === null || _session_ischemicTime === void 0 ? void 0 : _session_ischemicTime.durationInMilliseconds();
    }).filter(function(elem) {
        return elem != null;
    });
    if (durations.length === 0) {
        return {
            min: void 0,
            max: void 0,
            avg: void 0
        };
    }
    var min = Math.floor((_Math = Math).min.apply(_Math, _toConsumableArray(durations)));
    var max = Math.floor((_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations)));
    var avg = Math.floor(durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length);
    return {
        min: min > 0 ? min : void 0,
        max: max > 0 ? max : void 0,
        avg: avg > 0 ? avg : void 0
    };
}
// src/utils/calculateUserStats.ts
var import_regression = __toESM(require("regression"));
function calculateUserStats(sessions, users) {
    var validUsers = users.filter(function(user) {
        return user.email != null;
    });
    var validSessions = sessions.filter(function(session) {
        return session.createdBy != null;
    });
    var paragonixUsers = validUsers.filter(function(user) {
        return user.email.includes("@paragonixtechnologies.com");
    });
    var notParagonixUsers = validUsers.filter(function(user) {
        return !user.email.includes("@paragonixtechnologies.com");
    });
    var sessions2022 = validSessions.filter(function(session) {
        return session.createdAt != null && session.createdAt.getFullYear() === 2022;
    });
    var sessions2023 = validSessions.filter(function(session) {
        return session.createdAt != null && session.createdAt.getFullYear() === 2023;
    });
    var sessions2022GroupedByCreatedBy = groupSessionsByCreatedby(sessions2022);
    var sessions2023GroupedByCreatedBy = groupSessionsByCreatedby(sessions2023);
    var sessionsGroupedByCreatedBy = groupSessionsByCreatedby(_toConsumableArray(sessions2022).concat(_toConsumableArray(sessions2023)));
    var userCounts = Object.keys(sessionsGroupedByCreatedBy).filter(function(userId) {
        return validUsers.findIndex(function(user) {
            return user.id === userId;
        }) !== -1;
    }).map(function(userId) {
        var _sessions2022GroupedByCreatedBy_userId, _sessions2023GroupedByCreatedBy_userId, _sessionsGroupedByCreatedBy_userId;
        var user = validUsers.find(function(user2) {
            return user2.id === userId;
        });
        var _sessions2022GroupedByCreatedBy_userId_length, _sessions2023GroupedByCreatedBy_userId_length;
        return {
            user: {
                email: user.email,
                name: user.fullname,
                organization: user.organization
            },
            2022: (_sessions2022GroupedByCreatedBy_userId_length = (_sessions2022GroupedByCreatedBy_userId = sessions2022GroupedByCreatedBy[userId]) === null || _sessions2022GroupedByCreatedBy_userId === void 0 ? void 0 : _sessions2022GroupedByCreatedBy_userId.length) !== null && _sessions2022GroupedByCreatedBy_userId_length !== void 0 ? _sessions2022GroupedByCreatedBy_userId_length : 0,
            2023: (_sessions2023GroupedByCreatedBy_userId_length = (_sessions2023GroupedByCreatedBy_userId = sessions2023GroupedByCreatedBy[userId]) === null || _sessions2023GroupedByCreatedBy_userId === void 0 ? void 0 : _sessions2023GroupedByCreatedBy_userId.length) !== null && _sessions2023GroupedByCreatedBy_userId_length !== void 0 ? _sessions2023GroupedByCreatedBy_userId_length : 0,
            perYearAndMonth: Object.entries((_sessionsGroupedByCreatedBy_userId = sessionsGroupedByCreatedBy[userId]) === null || _sessionsGroupedByCreatedBy_userId === void 0 ? void 0 : _sessionsGroupedByCreatedBy_userId.reduce(function(acc, session) {
                var _session_createdAt, _session_createdAt1;
                var _session_createdAt_getFullYear;
                var year = (_session_createdAt_getFullYear = (_session_createdAt = session.createdAt) === null || _session_createdAt === void 0 ? void 0 : _session_createdAt.getFullYear()) !== null && _session_createdAt_getFullYear !== void 0 ? _session_createdAt_getFullYear : 0;
                var _session_createdAt_getMonth;
                var month = (_session_createdAt_getMonth = (_session_createdAt1 = session.createdAt) === null || _session_createdAt1 === void 0 ? void 0 : _session_createdAt1.getMonth()) !== null && _session_createdAt_getMonth !== void 0 ? _session_createdAt_getMonth : 0;
                var key = "".concat(year, "-").concat(month);
                if (acc[key] == null) {
                    acc[key] = 1;
                } else {
                    acc[key] += 1;
                }
                return acc;
            }, {})).map(function(param) {
                var _param = _slicedToArray(param, 2), key = _param[0], value = _param[1];
                return {
                    year: Number(key.split("-")[0]),
                    month: Number(key.split("-")[1]),
                    count: value
                };
            }),
            totalCreatedSessions: sessionsGroupedByCreatedBy[userId].length
        };
    }).sort(function(a, b) {
        return b.totalCreatedSessions - a.totalCreatedSessions;
    });
    return {
        stats: {
            totalSessions: sessions.length,
            totalUsers: users.length,
            totalParagonixUsers: paragonixUsers.length,
            totalNotParagonixUsers: notParagonixUsers.length,
            countSessionsCreatedByParagonixEmployees: {
                2022: sessions2022.filter(function(session) {
                    return paragonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length,
                2023: sessions2023.filter(function(session) {
                    return paragonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length,
                total: validSessions.filter(function(session) {
                    return paragonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length
            },
            countSessionsNotCreatedByParagonixEmployees: {
                2022: sessions2022.filter(function(session) {
                    return notParagonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length,
                2023: sessions2023.filter(function(session) {
                    return notParagonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length,
                total: validSessions.filter(function(session) {
                    return notParagonixUsers.some(function(user) {
                        return user.id === session.createdBy;
                    });
                }).length
            },
            userCounts: userCounts.map(function(userCount) {
                return _objectSpread({}, userCount, trend(userCount.perYearAndMonth));
            })
        },
        csv: toCSV(userCounts.map(function(userCount) {
            return _objectSpread({}, userCount, trend(userCount.perYearAndMonth));
        }))
    };
}
function groupSessionsByCreatedby(sessions) {
    return sessions.reduce(function(acc, session) {
        if (acc[session.createdBy] == null) {
            acc[session.createdBy] = [
                session
            ];
        } else {
            acc[session.createdBy].push(session);
        }
        return acc;
    }, {});
}
function trend(data) {
    var sorted = data.sort(function(a, b) {
        return a.year - b.year || a.month - b.month;
    });
    var filled = [
        {
            year: 2022,
            month: 0,
            count: 0
        },
        {
            year: 2022,
            month: 1,
            count: 0
        },
        {
            year: 2022,
            month: 2,
            count: 0
        },
        {
            year: 2022,
            month: 3,
            count: 0
        },
        {
            year: 2022,
            month: 4,
            count: 0
        },
        {
            year: 2022,
            month: 5,
            count: 0
        },
        {
            year: 2022,
            month: 6,
            count: 0
        },
        {
            year: 2022,
            month: 7,
            count: 0
        },
        {
            year: 2022,
            month: 8,
            count: 0
        },
        {
            year: 2022,
            month: 9,
            count: 0
        },
        {
            year: 2022,
            month: 10,
            count: 0
        },
        {
            year: 2022,
            month: 11,
            count: 0
        },
        {
            year: 2023,
            month: 0,
            count: 0
        },
        {
            year: 2023,
            month: 1,
            count: 0
        },
        {
            year: 2023,
            month: 2,
            count: 0
        }
    ].map(function(item, key) {
        var found = sorted.find(function(sortedItem) {
            return sortedItem.year === item.year && sortedItem.month === item.month;
        });
        if (found == null) {
            return _objectSpreadProps(_objectSpread({}, item), {
                key: key
            });
        }
        return _objectSpreadProps(_objectSpread({}, found), {
            key: key
        });
    });
    var values = filled.map(function(item) {
        return [
            item.key,
            item.count
        ];
    });
    var result = import_regression.default.linear(values);
    if (result.equation[0] > 0) {
        return {
            trend: "UP" /* UP */ ,
            trendElems: filled.map(function(item) {
                return item.count;
            }).join(", ")
        };
    }
    if (result.equation[0] < 0) {
        return {
            trend: "DOWN" /* DOWN */ ,
            trendElems: filled.map(function(item) {
                return item.count;
            }).join(", ")
        };
    }
    return {
        trend: "FLAT" /* FLAT */ ,
        trendElems: filled.map(function(item) {
            return item.count;
        }).join(", ")
    };
}
function toCSV(userCounts) {
    return {
        columns: [
            {
                id: "name",
                displayName: "Name"
            },
            {
                id: "email",
                displayName: "Email"
            },
            {
                id: "organization",
                displayName: "Organization"
            },
            {
                id: "year2022",
                displayName: "Sessions created in 2022"
            },
            {
                id: "year2023",
                displayName: "Sessions created in 2023"
            },
            {
                id: "total",
                displayName: "Total sessions created"
            },
            {
                id: "trend",
                displayName: "Trend"
            },
            {
                id: "monthlyElems",
                displayName: "Monthly Count"
            }
        ],
        data: userCounts.map(function(item) {
            return {
                name: item.user.name,
                email: item.user.email,
                organization: item.user.organization,
                year2022: item["2022"],
                year2023: item["2023"],
                total: item.totalCreatedSessions,
                trend: item.trend,
                monthlyElems: item.trendElems
            };
        })
    };
}
// src/utils/filterSessions.ts
function filterSessions(sessions) {
    var filters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var filteredSessions = sessions;
    if (filters.startDate != null) {
        var startDate = filters.startDate;
        filteredSessions = filteredSessions.filter(function(session) {
            if (session.createdAt == null) {
                return false;
            }
            var time = session.createdAt.getTime();
            return time >= startDate.getTime();
        });
    }
    if (filters.endDate != null) {
        var endDate = filters.endDate;
        filteredSessions = filteredSessions.filter(function(session) {
            if (session.createdAt == null) {
                return false;
            }
            var time = session.createdAt.getTime();
            return time <= endDate.getTime();
        });
    }
    if (filters.productType != null && filters.productType.length > 0) {
        var productType = filters.productType;
        filteredSessions = filteredSessions.filter(function(session) {
            return productType.some(function(type) {
                return type === session.product;
            });
        });
    }
    if (filters.donationType != null && filters.donationType.length > 0) {
        var donationType = filters.donationType;
        filteredSessions = filteredSessions.filter(function(session) {
            return donationType.includes(session.donationType);
        });
    }
    if (filters.sessionType != null && filters.sessionType.length > 0) {
        var sessionType = filters.sessionType;
        filteredSessions = filteredSessions.filter(function(session) {
            return sessionType.includes(session.sessionType);
        });
    }
    if (filters.finished != null && filters.finished.length > 0) {
        var finished = filters.finished;
        filteredSessions = filteredSessions.filter(function(session) {
            return finished.includes(session.finished);
        });
    }
    if (filters.logging != null && filters.logging.length > 0) {
        var logging = filters.logging;
        filteredSessions = filteredSessions.filter(function(session) {
            return logging.includes(session.loggerState === "STARTED");
        });
    }
    if (filters.stopReminderSent != null && filters.stopReminderSent.length > 0) {
        var stopReminderSent = filters.stopReminderSent;
        var _session_metadata_stopReminderSent;
        filteredSessions = filteredSessions.filter(function(session) {
            var _session_metadata;
            return stopReminderSent.includes((_session_metadata_stopReminderSent = (_session_metadata = session.metadata) === null || _session_metadata === void 0 ? void 0 : _session_metadata.stopReminderSent) !== null && _session_metadata_stopReminderSent !== void 0 ? _session_metadata_stopReminderSent : false);
        });
    }
    if (filters.forceStopAfter48Hours != null && filters.forceStopAfter48Hours.length > 0) {
        var forceStopAfter48Hours = filters.forceStopAfter48Hours;
        var _session_metadata_forceStopAfter48Hours;
        filteredSessions = filteredSessions.filter(function(session) {
            var _session_metadata;
            return forceStopAfter48Hours.includes((_session_metadata_forceStopAfter48Hours = (_session_metadata = session.metadata) === null || _session_metadata === void 0 ? void 0 : _session_metadata.forceStopAfter48Hours) !== null && _session_metadata_forceStopAfter48Hours !== void 0 ? _session_metadata_forceStopAfter48Hours : false);
        });
    }
    if (filters.loggerConnected != null && filters.loggerConnected.length > 0) {
        var loggerConnected = filters.loggerConnected;
        filteredSessions = filteredSessions.filter(function(session) {
            if (loggerConnected.includes(true) && loggerConnected.includes(false)) {
                return true;
            }
            if (loggerConnected.includes(true)) {
                return session.loggerSerialNo != null;
            }
            if (loggerConnected.includes(false)) {
                return session.loggerSerialNo == null;
            }
            return true;
        });
    }
    return filteredSessions;
}
// src/utils/generateCsvDataFromExportables.ts
var import_translations9 = __toESM(require("@packages/translations"));
var import_date_fns = require("date-fns");
function generateCsvDataFromExportables(session) {
    var readings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], timeline = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var t = import_translations9.default.t;
    return {
        columns: [
            {
                id: "event",
                displayName: t("export_header_event_name")
            },
            {
                id: "value",
                displayName: t("export_header_event_value")
            },
            {
                id: "time",
                displayName: t("export_header_time")
            },
            {
                id: "probe",
                displayName: t("export_header_probe_temperature")
            },
            {
                id: "ambient",
                displayName: t("export_header_ambient_temperature")
            },
            session.product === "baroguard" /* BAROGUARD */  ? {
                id: "pressure",
                displayName: t("export_header_pressure")
            } : null,
            session.product === "baroguard" /* BAROGUARD */  ? {
                id: "pumpVoltage",
                displayName: t("export_header_pump_voltage")
            } : null,
            {
                id: "description",
                displayName: t("export_header_description")
            }
        ].filter(function(elem) {
            return elem != null;
        }),
        data: readings.concat(timeline).sort(function(a, b) {
            return a.timestamp.getTime() - b.timestamp.getTime();
        }).map(function(item) {
            var probe2;
            var ambient;
            var pressure3;
            var pumpVoltage;
            if (_instanceof(item, Reading)) {
                var _item_probe, _item_ambient, _item_pressure, _item_pumpVoltage;
                probe2 = (_item_probe = item.probe) === null || _item_probe === void 0 ? void 0 : _item_probe.toFixed(2);
                ambient = (_item_ambient = item.ambient) === null || _item_ambient === void 0 ? void 0 : _item_ambient.toFixed(2);
                pressure3 = (_item_pressure = item.pressure) === null || _item_pressure === void 0 ? void 0 : _item_pressure.toFixed(2);
                pumpVoltage = (_item_pumpVoltage = item.pumpVoltage) === null || _item_pumpVoltage === void 0 ? void 0 : _item_pumpVoltage.toFixed(2);
            }
            return {
                event: item.exportEvent(),
                value: item.exportValue(session.product),
                time: (0, import_date_fns.format)(item.timestamp, "yyyy-MM-dd'T'HH:mm:ssxxxxx"),
                probe: probe2,
                ambient: ambient,
                pressure: pressure3,
                pumpVoltage: pumpVoltage,
                description: item.exportDescription(session)
            };
        })
    };
}
// src/utils/generateCsvDataFromSessions.ts
var import_translations10 = __toESM(require("@packages/translations"));
var import_utils7 = require("@packages/utils");
var import_date_fns2 = require("date-fns");
function generateCsvDataFromSessions(sessions) {
    var t = import_translations10.default.t;
    var _session_joinKey_toString;
    return {
        columns: [
            {
                id: "joinKey",
                displayName: t("key")
            },
            {
                id: "createdAt",
                displayName: t("date")
            },
            {
                id: "loggerState",
                displayName: t("logger_state")
            },
            {
                id: "organ",
                displayName: t("organ")
            },
            {
                id: "donationType",
                displayName: t("donation_type")
            },
            {
                id: "sessionType",
                displayName: t("session_type")
            },
            {
                id: "minTemperature",
                displayName: "".concat(t("min_abbrevation"), " ").concat(t("temperature_abbrevation"))
            },
            {
                id: "maxTemperature",
                displayName: "".concat(t("max_abbrevation"), " ").concat(t("temperature_abbrevation"))
            },
            {
                id: "avgTemperature",
                displayName: "".concat(t("avg_abbrevation"), " ").concat(t("temperature_abbrevation"))
            },
            {
                id: "ischemicTime",
                displayName: t("ischemic_time_title")
            }
        ],
        data: sessions.map(function(session) {
            var _session_reportData, _session_reportData1, _session_reportData2, _session_reportData3, _session_reportData4, _session_reportData5;
            return {
                joinKey: (_session_joinKey_toString = session.joinKey.toString()) !== null && _session_joinKey_toString !== void 0 ? _session_joinKey_toString : "-",
                createdAt: session.createdAt != null ? (0, import_date_fns2.format)(session.createdAt, "yyyy-MM-dd'T'HH:mm:ssxxxxx") : "-",
                loggerState: session.getState().toString(),
                organ: session.product ? ProductUtil.toHeading(session.product) : "-",
                donationType: session.donationType ? DonationTypeUtil.toUIString(session.donationType) : "-",
                sessionType: session.sessionType ? SessionTypeUtil.toUIString(session.sessionType) : "-",
                minTemperature: ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMinimum) != null ? (0, import_utils7.formatTemperature)((_session_reportData1 = session.reportData) === null || _session_reportData1 === void 0 ? void 0 : _session_reportData1.probeMinimum) : "-",
                maxTemperature: ((_session_reportData2 = session.reportData) === null || _session_reportData2 === void 0 ? void 0 : _session_reportData2.probeMaximum) != null ? (0, import_utils7.formatTemperature)((_session_reportData3 = session.reportData) === null || _session_reportData3 === void 0 ? void 0 : _session_reportData3.probeMaximum) : "-",
                avgTemperature: ((_session_reportData4 = session.reportData) === null || _session_reportData4 === void 0 ? void 0 : _session_reportData4.probeAverage) != null ? (0, import_utils7.formatTemperature)((_session_reportData5 = session.reportData) === null || _session_reportData5 === void 0 ? void 0 : _session_reportData5.probeAverage) : "-",
                ischemicTime: session.ischemicTime != null ? session.ischemicTime.durationString() : "-"
            };
        })
    };
}
// src/utils/generateSessionMetrics.ts
var import_utils8 = require("@packages/utils");
function generateSessionMetrics(sessions) {
    var lungguardSessions = sessions.filter(function(session) {
        return session.product === "lungguard" /* LUNGGUARD */ ;
    });
    var baroguardSessions = sessions.filter(function(session) {
        return session.product === "baroguard" /* BAROGUARD */ ;
    });
    var sherpapakSessions = sessions.filter(function(session) {
        return session.product === "sherpapak-cts" /* SHERPAPAK */  || session.product == null;
    });
    var liverguardSessions = sessions.filter(function(session) {
        return session.product === "liverguard" /* LIVERGUARD */ ;
    });
    var pancreaspakSessions = sessions.filter(function(session) {
        return session.product === "pancreaspak" /* PANCREASPAK */ ;
    });
    var ktsSessions = sessions.filter(function(session) {
        return session.product === "sherpapak-kts" /* KTS */ ;
    });
    var vantagepointSessions = sessions.filter(function(session) {
        return session.product === "vantage-point" /* VANTAGEPOINT */ ;
    });
    return {
        all: {
            temperature: temperature2(sessions),
            distance: distance3(sessions),
            duration: duration2(sessions),
            loggingDuration: loggingDuration2(sessions),
            ischemicTime: ischemicTime3(sessions)
        },
        lungguard: {
            temperature: temperature2(lungguardSessions),
            distance: distance3(lungguardSessions),
            duration: duration2(lungguardSessions),
            loggingDuration: loggingDuration2(lungguardSessions),
            ischemicTime: ischemicTime3(lungguardSessions)
        },
        baroguard: {
            temperature: temperature2(baroguardSessions),
            pressure: pressure2(baroguardSessions),
            distance: distance3(baroguardSessions),
            duration: duration2(baroguardSessions),
            loggingDuration: loggingDuration2(baroguardSessions),
            ischemicTime: ischemicTime3(baroguardSessions)
        },
        sherpapak: {
            temperature: temperature2(sherpapakSessions),
            distance: distance3(sherpapakSessions),
            duration: duration2(sherpapakSessions),
            loggingDuration: loggingDuration2(sherpapakSessions),
            ischemicTime: ischemicTime3(sherpapakSessions)
        },
        liverguard: {
            temperature: temperature2(liverguardSessions),
            distance: distance3(liverguardSessions),
            duration: duration2(liverguardSessions),
            loggingDuration: loggingDuration2(liverguardSessions),
            ischemicTime: ischemicTime3(liverguardSessions)
        },
        pancreaspak: {
            temperature: temperature2(pancreaspakSessions),
            distance: distance3(pancreaspakSessions),
            duration: duration2(pancreaspakSessions),
            loggingDuration: loggingDuration2(pancreaspakSessions),
            ischemicTime: ischemicTime3(pancreaspakSessions)
        },
        kts: {
            temperature: temperature2(ktsSessions),
            distance: distance3(ktsSessions),
            duration: duration2(ktsSessions),
            loggingDuration: loggingDuration2(ktsSessions),
            ischemicTime: ischemicTime3(ktsSessions)
        },
        vantagepoint: {
            temperature: temperature2(vantagepointSessions),
            distance: distance3(vantagepointSessions),
            duration: duration2(vantagepointSessions),
            loggingDuration: loggingDuration2(vantagepointSessions),
            ischemicTime: ischemicTime3(vantagepointSessions)
        }
    };
}
function temperature2(sessions) {
    var minimums = [];
    var maximums = [];
    var averages = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            var _session_reportData, _session_reportData1, _session_reportData2;
            if (((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.probeMinimum) != null) {
                var _session_reportData3;
                minimums.push((_session_reportData3 = session.reportData) === null || _session_reportData3 === void 0 ? void 0 : _session_reportData3.probeMinimum);
            }
            if (((_session_reportData1 = session.reportData) === null || _session_reportData1 === void 0 ? void 0 : _session_reportData1.probeMaximum) != null) {
                var _session_reportData4;
                maximums.push((_session_reportData4 = session.reportData) === null || _session_reportData4 === void 0 ? void 0 : _session_reportData4.probeMaximum);
            }
            if (((_session_reportData2 = session.reportData) === null || _session_reportData2 === void 0 ? void 0 : _session_reportData2.probeAverage) != null) {
                var _session_reportData5;
                averages.push((_session_reportData5 = session.reportData) === null || _session_reportData5 === void 0 ? void 0 : _session_reportData5.probeAverage);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        min: minimums.length > 0 ? minimums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / minimums.length : void 0,
        max: maximums.length > 0 ? maximums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / maximums.length : void 0,
        avg: averages.length > 0 ? averages.reduce(function(sum, current) {
            return sum + current;
        }, 0) / averages.length : void 0
    };
}
function pressure2(sessions) {
    var minimums = [];
    var maximums = [];
    var averages = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sessions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var session = _step.value;
            var _session_reportData, _session_reportData1, _session_reportData2;
            if (((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.pressureMinimum) != null) {
                var _session_reportData3;
                minimums.push((_session_reportData3 = session.reportData) === null || _session_reportData3 === void 0 ? void 0 : _session_reportData3.pressureMinimum);
            }
            if (((_session_reportData1 = session.reportData) === null || _session_reportData1 === void 0 ? void 0 : _session_reportData1.pressureMaximum) != null) {
                var _session_reportData4;
                maximums.push((_session_reportData4 = session.reportData) === null || _session_reportData4 === void 0 ? void 0 : _session_reportData4.pressureMaximum);
            }
            if (((_session_reportData2 = session.reportData) === null || _session_reportData2 === void 0 ? void 0 : _session_reportData2.pressureAverage) != null) {
                var _session_reportData5;
                averages.push((_session_reportData5 = session.reportData) === null || _session_reportData5 === void 0 ? void 0 : _session_reportData5.pressureAverage);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return {
        min: minimums.length > 0 ? minimums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / minimums.length : void 0,
        max: maximums.length > 0 ? maximums.reduce(function(sum, current) {
            return sum + current;
        }, 0) / maximums.length : void 0,
        avg: averages.length > 0 ? averages.reduce(function(sum, current) {
            return sum + current;
        }, 0) / averages.length : void 0
    };
}
function distance3(sessions) {
    var _Math, _Math1;
    var distances = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.distance;
    });
    if (distances.length === 0) {
        return {
            min: void 0,
            max: void 0,
            avg: void 0
        };
    }
    return {
        min: Math.floor((_Math = Math).min.apply(_Math, _toConsumableArray(distances))),
        max: Math.floor((_Math1 = Math).max.apply(_Math1, _toConsumableArray(distances))),
        avg: Math.floor(distances.reduce(function(sum, current) {
            return sum + current;
        }, 0) / distances.length)
    };
}
function duration2(sessions) {
    var _Math, _Math1;
    var durations = sessions.map(function(session) {
        return session.durationInMilliseconds();
    }).filter(function(elem) {
        return elem != null;
    });
    if (durations.length === 0) {
        return {
            min: "-",
            max: "-",
            avg: "-"
        };
    }
    var min = Math.floor((_Math = Math).min.apply(_Math, _toConsumableArray(durations)));
    var max = Math.floor((_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations)));
    var avg = Math.floor(durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length);
    return {
        min: min > 0 ? (0, import_utils8.millisecondsToTime)(min, {
            seconds: false
        }) : "-",
        max: max > 0 ? (0, import_utils8.millisecondsToTime)(max, {
            seconds: false
        }) : "-",
        avg: avg > 0 ? (0, import_utils8.millisecondsToTime)(avg, {
            seconds: false
        }) : "-"
    };
}
function loggingDuration2(sessions) {
    var _Math, _Math1;
    var durations = sessions.filter(function(session) {
        var _session_reportData;
        return ((_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis) != null;
    }).map(function(session) {
        var _session_reportData;
        return (_session_reportData = session.reportData) === null || _session_reportData === void 0 ? void 0 : _session_reportData.loggingDurationMillis;
    });
    if (durations.length === 0) {
        return {
            min: "-",
            max: "-",
            avg: "-"
        };
    }
    var min = Math.floor((_Math = Math).min.apply(_Math, _toConsumableArray(durations)));
    var max = Math.floor((_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations)));
    var avg = Math.floor(durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length);
    return {
        min: min > 0 ? (0, import_utils8.millisecondsToTime)(min, {
            seconds: false
        }) : "-",
        max: max > 0 ? (0, import_utils8.millisecondsToTime)(max, {
            seconds: false
        }) : "-",
        avg: avg > 0 ? (0, import_utils8.millisecondsToTime)(avg, {
            seconds: false
        }) : "-"
    };
}
function ischemicTime3(sessions) {
    var _Math, _Math1;
    var durations = sessions.map(function(session) {
        var _session_ischemicTime;
        return (_session_ischemicTime = session.ischemicTime) === null || _session_ischemicTime === void 0 ? void 0 : _session_ischemicTime.durationInMilliseconds();
    }).filter(function(elem) {
        return elem != null;
    });
    if (durations.length === 0) {
        return {
            min: "-",
            max: "-",
            avg: "-"
        };
    }
    var min = Math.floor((_Math = Math).min.apply(_Math, _toConsumableArray(durations)));
    var max = Math.floor((_Math1 = Math).max.apply(_Math1, _toConsumableArray(durations)));
    var avg = Math.floor(durations.reduce(function(sum, current) {
        return sum + current;
    }, 0) / durations.length);
    return {
        min: min > 0 ? (0, import_utils8.millisecondsToTime)(min, {
            seconds: false
        }) : "-",
        max: max > 0 ? (0, import_utils8.millisecondsToTime)(max, {
            seconds: false
        }) : "-",
        avg: avg > 0 ? (0, import_utils8.millisecondsToTime)(avg, {
            seconds: false
        }) : "-"
    };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    AdvancedTracking: AdvancedTracking,
    Airport: Airport,
    AuditLog: AuditLog,
    AuditLogType: AuditLogType,
    AuditLogTypeUtil: AuditLogTypeUtil,
    CannulationType: CannulationType,
    CannulationTypeUtil: CannulationTypeUtil,
    Destination: Destination,
    DistanceUnit: DistanceUnit,
    Document: Document,
    DonationType: DonationType,
    DonationTypeUtil: DonationTypeUtil,
    Flight: Flight,
    FlightDestinationType: FlightDestinationType,
    FlightPosition: FlightPosition,
    FlightState: FlightState,
    FlightStateUtil: FlightStateUtil,
    Log: Log,
    LoggerLocation: LoggerLocation,
    LungPositionType: LungPositionType,
    Notification: Notification,
    NotificationUtil: NotificationUtil,
    OrganPositionType: OrganPositionType,
    OrganType: OrganType,
    OrganTypeUtil: OrganTypeUtil,
    Organization: Organization,
    OrganizationMember: OrganizationMember,
    OrganizationMemberAccessRole: OrganizationMemberAccessRole,
    OrganizationMemberAccessRoleUtil: OrganizationMemberAccessRoleUtil,
    OrganizationMemberDeactivationReason: OrganizationMemberDeactivationReason,
    OrganizationMemberDeactivationReasonUtil: OrganizationMemberDeactivationReasonUtil,
    OrganizationMemberRole: OrganizationMemberRole,
    OrganizationMemberStatus: OrganizationMemberStatus,
    OrganizationMemberStatusUtil: OrganizationMemberStatusUtil,
    OrganizationOption: OrganizationOption,
    OrganizationPreselectedMember: OrganizationPreselectedMember,
    OrganizationStatus: OrganizationStatus,
    OrganizationStatusUtil: OrganizationStatusUtil,
    OrganizationType: OrganizationType,
    OrganizationUnregisteredInvite: OrganizationUnregisteredInvite,
    Product: Product,
    ProductType: ProductType,
    ProductUtil: ProductUtil,
    Reading: Reading,
    ReadingCompressed: ReadingCompressed,
    Session: Session,
    SessionIschemicTime: SessionIschemicTime,
    SessionMember: SessionMember,
    SessionMetadata: SessionMetadata,
    SessionMetrics: SessionMetrics,
    SessionReportData: SessionReportData,
    SessionState: SessionState,
    SessionType: SessionType,
    SessionTypeUtil: SessionTypeUtil,
    TimelineEntry: TimelineEntry,
    TimelineEntryType: TimelineEntryType,
    TimelineEntryTypeUtil: TimelineEntryTypeUtil,
    Tutorial: Tutorial,
    User: User,
    UserDeactivationReason: UserDeactivationReason,
    UserDeactivationReasonUtil: UserDeactivationReasonUtil,
    UserSettings: UserSettings,
    auditLogConverter: auditLogConverter,
    calculateSessionStats: calculateSessionStats,
    calculateUserStats: calculateUserStats,
    destinationConverter: destinationConverter,
    documentConverter: documentConverter,
    filterSessions: filterSessions,
    findClosestReadingTime: findClosestReadingTime,
    generateCsvDataFromExportables: generateCsvDataFromExportables,
    generateCsvDataFromSessions: generateCsvDataFromSessions,
    generateEmailReportData: generateEmailReportData,
    generateSessionMetrics: generateSessionMetrics,
    locationConverter: locationConverter,
    logConverter: logConverter,
    organizationConverter: organizationConverter,
    organizationMemberConverter: organizationMemberConverter,
    organizationMemberRoleConverter: organizationMemberRoleConverter,
    organizationOptionConverter: organizationOptionConverter,
    organizationPreselectedMemberConverter: organizationPreselectedMemberConverter,
    organizationTypeConverter: organizationTypeConverter,
    organizationUnregisteredInviteConverter: organizationUnregisteredInviteConverter,
    productConverter: productConverter,
    sessionConverter: sessionConverter,
    sessionMemberConverter: sessionMemberConverter,
    timelineConverter: timelineConverter,
    tiveLocationConverter: tiveLocationConverter,
    tutorialConverter: tutorialConverter,
    userConverter: userConverter
});
